{
	"dialog.ok": "Tamam",
	"dialog.cancel": "İptal",
	"dialog.confirm": "Onayla",
	"dialog.close": "Kapat",
	"dialog.import": "İçe Aktar",
	"dialog.save": "Kaydet",
	"dialog.discard": "Vazgeç",
	"dialog.dontshowagain": "Bir Daha Gösterme",
	"data.cube": "Küp",
	"data.group": "Grup",
	"data.texture": "Doku",
	"data.plugin": "Eklenti",
	"data.preview": "Önizleme",
	"data.toolbar": "Araç Çubuğu",
	"data.image": "Görsel",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Sil",
	"keys.space": "Boşluk",
	"keys.leftclick": "Sol Tıklama",
	"keys.middleclick": "Orta Tıklama",
	"keys.rightclick": "Sağ Tıklama",
	"keys.tab": "Sekme",
	"keys.backspace": "Geri Sil",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Bağlam Menüsü",
	"keys.left": "Sol",
	"keys.up": "Yukarı",
	"keys.right": "Sağ",
	"keys.down": "Aşağı",
	"keys.pageup": "Sayfa Yukarı",
	"keys.pagedown": "Sayfa Aşağı",
	"keys.plus": "Artı",
	"keys.comma": "Virgül",
	"keys.point": "Nokta",
	"keys.minus": "Eksi",
	"keys.cross": "Çarpı",
	"keys.end": "Son",
	"keys.pos1": "Başlangıç",
	"keys.printscreen": "Ekran Görüntüsü",
	"keys.pause": "Duraklat",
	"message.rotation_limit.title": "Döndürme Sınırları",
	"message.rotation_limit.message": "Döndürmeler Minecraft tarafından tek bir eksenle sınırlandırılmıştır. Farklı bir eksende döndürmek, diğer eksenlerdeki tüm döndürmeleri temizleyecektir. Başka amaçlar için modelleme yapıyorsanız ve serbest döndürmeye ihtiyacınız varsa modeli \"Genel Model\"e dönüştürün.",
	"message.file_not_found.title": "Dosya Bulunamadı",
	"message.file_not_found.message": "Blockbench istenen dosyayı bulamadı. Dosyanın bulutta değil, yerel olarak kaydedildiğinden emin olun.",
	"message.screenshot.title": "Ekran Görüntüsü",
	"message.screenshot.clipboard": "Pano",
	"message.screenshot.right_click": "Kopyalamak için ekran görüntüsüne sağ tıklayın veya uzun basın",
	"message.invalid_file.title": "Geçersiz Dosya",
	"message.invalid_file.message": "JSON dosyası açılamadı: %0",
	"message.invalid_model.title": "Geçersiz Model Dosyası",
	"message.invalid_model.message": "Bu dosya geçerli model verileri içermiyor.",
	"message.child_model_only.title": "Boş Alt Model",
	"message.child_model_only.message": "Bu dosya %0'ın bir alt öğesidir ve bir model içermez.",
	"message.unsaved_textures.title": "Kaydedilmemiş Dokular",
	"message.unsaved_textures.message": "Modelinizde kaydedilmemiş dokular var. Bunları kaydettiğinizden ve kaynak paketinizdeki doğru klasöre yapıştırdığınızdan emin olun.",
	"message.model_clipping.title": "Model Çok Büyük",
	"message.model_clipping.message": "Modeliniz, Minecraft tarafından izin verilen blok sınırından daha büyük %0 küp içeriyor. Bu model Minecraft'ta çalışmayacaktır.",
	"message.loose_texture.title": "Doku İçe Aktarma",
	"message.loose_texture.message": "İçe aktarılan doku bir kaynak paketinde yer almıyor. Minecraft, yalnızca yüklenmiş bir kaynak paketinin dokular klasöründeki dokuları yükleyebilir.",
	"message.loose_texture.change": "Yolu Değiştir",
	"message.update_res.title": "Doku Çözünürlüğü",
	"message.update_res.message": "Proje çözünürlüğünü bu dokunun çözünürlüğüne güncellemek ister misiniz? Dokunuz normalden daha yüksek bir çözünürlüğe sahipse 'İptal'e tıklayın.",
	"message.update_res.update": "Güncelle",
	"message.bedrock_overwrite_error.message": "Blockbench bu modeli eski dosyayla birleştiremez",
	"message.bedrock_overwrite_error.backup_overwrite": "Yedek Oluştur ve Üzerine Yaz",
	"message.bedrock_overwrite_error.overwrite": "Üzerine Yaz",
	"message.close_warning.message": "Modelinizi kaydetmek istiyor musunuz?",
	"message.close_warning.web": "Mevcut çalışmanız kaybolacak. Çıkmak istediğinizden emin misiniz?",
	"message.default_textures.title": "Varsayılan Dokular",
	"message.default_textures.message": "Varsayılan kaynak paketinin \"textures\" klasörünü seçin",
	"message.default_textures.detail": "Varsayılan kaynak paketini Minecraft jar dosyasından çıkarın veya google'da aratıp indirin. Ardından \"textures\" klasörünü bulun ve açın. Blockbench bu konumu hatırlayacak ve mevcut kaynak paketinde bulamazsa dokuları oradan almaya çalışacaktır.",
	"message.default_textures.select": "Varsayılan \"textures\" klasörünü seçin",
	"message.image_editor.title": "Bir resim düzenleyici seçin",
	"message.image_editor.file": "Dosya Seç...",
	"message.image_editor.exe": "Resim düzenleyici yürütülebilir dosyasını seçin",
	"message.display_skin.title": "Minecraft Kaplaması",
	"message.display_skin.message": "Bilgisayarınızdan bir kaplama dosyası seçin veya bir oyuncu adı girin",
	"message.display_skin.upload": "Dosya Seç",
	"message.display_skin.reset": "Sıfırla",
	"message.invalid_plugin": "Geçersiz Eklenti Dosyası, Konsola Bakın",
	"message.load_plugin_app": "Bu eklentinin bilgisayarınızda değişiklik yapmasına izin vermek istiyor musunuz? Yalnızca güvendiğiniz yazarların eklentilerini yükleyin.",
	"message.load_plugin_web": "Bu eklentiyi yüklemek istiyor musunuz? Yalnızca güvendiğiniz yazarların eklentilerini yükleyin.",
	"message.preset_no_info": "Ön ayar bu yuva için bilgi içermiyor",
	"message.restart_to_update": "Değişiklikleri uygulamak için Blockbench'i yeniden başlatın",
	"message.save_file": "%0 olarak kaydedildi",
	"dialog.project.title": "Proje",
	"dialog.project.name": "Dosya Adı",
	"dialog.project.parent": "Üst Model",
	"dialog.project.geoname": "Model Tanımlayıcısı",
	"dialog.project.ao": "Ortam Kapanması",
	"dialog.texture.title": "Doku",
	"dialog.texture.variable": "Değişken",
	"dialog.texture.namespace": "Ad Alanı",
	"dialog.texture.folder": "Klasör",
	"dialog.extrude.title": "Görüntüyü Dışa Çıkar",
	"dialog.extrude.mode": "Tarama Modu",
	"dialog.extrude.mode.areas": "Alanlar",
	"dialog.extrude.mode.lines": "Çizgiler",
	"dialog.extrude.mode.columns": "Sütunlar",
	"dialog.extrude.mode.pixels": "Pikseller",
	"dialog.extrude.opacity": "Minimum Opaklık",
	"dialog.extrude.scan": "Tara ve İçe Aktar",
	"dialog.display_preset.title": "Ön Ayar Oluştur",
	"dialog.display_preset.message": "Kaydetmek istediğiniz yuvaları seçin",
	"dialog.display_preset.create": "Oluştur",
	"dialog.select.title": "Seç",
	"dialog.select.group": "Seçili Grupta",
	"dialog.select.name": "İsim İçerir",
	"dialog.select.random": "Rastgele Şans (%)",
	"dialog.select.select": "Seç",
	"dialog.scale.title": "Modeli Ölçeklendir",
	"dialog.scale.axis": "Eksen",
	"dialog.scale.clipping": "Model kırpma: Modeliniz tuval için çok büyük",
	"dialog.scale.confirm": "Ölçeklendir",
	"dialog.plugins.title": "Eklentiler",
	"dialog.plugins.installed": "Yüklü",
	"dialog.plugins.available": "Mevcut",
	"dialog.plugins.install": "Yükle",
	"dialog.plugins.uninstall": "Kaldır",
	"dialog.plugins.reload": "Yeniden Yükle",
	"dialog.plugins.none_installed": "Yüklü eklenti yok",
	"dialog.plugins.none_available": "Mevcut eklenti yok",
	"dialog.plugins.web_only": "Yalnızca web uygulaması için",
	"dialog.plugins.app_only": "Yalnızca masaüstü uygulaması için",
	"dialog.plugins.author": "%0 tarafından",
	"dialog.create_texture.folder": "Klasör",
	"dialog.create_texture.resolution": "Çözünürlük",
	"dialog.input.title": "Giriş",
	"dialog.settings.settings": "Ayarlar",
	"dialog.settings.keybinds": "Tuş Atamaları",
	"dialog.settings.about": "Hakkında",
	"layout.color.back": "Geri",
	"layout.color.back.desc": "Arka planlar ve giriş alanları",
	"layout.color.dark": "Koyu",
	"layout.color.dark.desc": "Tuval arka planı",
	"layout.color.ui": "Arayüz",
	"layout.color.ui.desc": "Ana arayüz rengi",
	"layout.color.bright_ui": "Parlak Arayüz",
	"layout.color.bright_ui.desc": "Bağlam menüleri ve araç ipuçları",
	"layout.color.button": "Düğme",
	"layout.color.button.desc": "Düğmeler ve anahtarlar",
	"layout.color.selected": "Seçili",
	"layout.color.selected.desc": "Seçili sekmeler ve nesneler",
	"layout.color.border": "Kenarlık",
	"layout.color.border.desc": "Düğmelerin ve girişlerin kenarlığı",
	"layout.color.accent": "Vurgu",
	"layout.color.accent.desc": "Kaydırıcı başlığı ve diğer detaylar",
	"layout.color.grid": "Izgara",
	"layout.color.grid.desc": "3B önizleme ızgarası",
	"layout.color.text": "Metin",
	"layout.color.text.desc": "Normal metin",
	"layout.color.light": "Açık",
	"layout.color.light.desc": "Vurgulanan metin",
	"layout.color.accent_text": "Vurgu Metni",
	"layout.color.accent_text.desc": "Vurgu arka planlarındaki metin",
	"layout.font.main": "Ana Yazı Tipi",
	"layout.font.headline": "Başlık Yazı Tipi",
	"about.version": "Sürüm:",
	"settings.category.general": "Genel",
	"settings.category.preview": "Önizleme",
	"settings.category.grid": "Izgara",
	"settings.category.edit": "Düzenle",
	"settings.category.snapping": "Yaslama",
	"settings.category.defaults": "Varsayılanlar",
	"settings.category.dialogs": "Diyaloglar",
	"settings.category.export": "Dışa Aktar",
	"settings.language": "Dil",
	"settings.language.desc": "Arayüz dili",
	"settings.backup_interval": "Yedekleme Aralığı",
	"settings.backup_interval.desc": "Otomatik yedeklemelerin dakika cinsinden aralığı",
	"settings.origin_size": "Merkez İşaretleyici",
	"settings.origin_size.desc": "Merkez noktası işaretçisinin boyutu",
	"settings.control_size": "Dönüşüm Yardımcısı Boyutu",
	"settings.control_size.desc": "Dönüşüm yardımcısının boyutu",
	"settings.display_skin": "Minecraft Kaplaması",
	"settings.display_skin.desc": "Referans oyuncu modeli için kullanılan kaplama",
	"settings.shading": "Gölgelendirme",
	"settings.shading.desc": "Önizlemede gölgelendirmeyi etkinleştir",
	"settings.base_grid": "Küçük Izgara",
	"settings.base_grid.desc": "Küçük ızgara ve eksenleri göster",
	"settings.large_grid": "Blok Izgarası",
	"settings.large_grid.desc": "16x16 blok boyutunda ızgara göster",
	"settings.full_grid": "Hassas Blok Izgarası",
	"settings.full_grid.desc": "Piksel hassasiyetinde blok ızgarası göster",
	"settings.large_box": "Boyut Sınırı Kutusu",
	"settings.large_box.desc": "Boyut sınırı sınırlarını göster",
	"settings.display_grid": "Görüntüleme Modu Izgarası",
	"settings.display_grid.desc": "Görüntüleme modunda ızgarayı göster",
	"settings.undo_limit": "Geri Alma Sınırı",
	"settings.undo_limit.desc": "Geri alabileceğiniz adım sayısı",
	"settings.local_move": "Göreceli Eksenlerde Taşı",
	"settings.local_move.desc": "Mümkünse, döndürülmüş öğeleri kendi eksenlerinde taşı",
	"settings.canvas_unselect": "Arka Plana Tıklandığında Seçimi Kaldır",
	"settings.canvas_unselect.desc": "Modelin arkasındaki arka plana veya zaman çizelgesine tıklandığında tüm öğelerin seçimini kaldırır",
	"settings.paint_side_restrict": "Fırçayı Tarafa Kısıtla",
	"settings.paint_side_restrict.desc": "Fırçaları yalnızca mevcut tarafa boyamakla kısıtla",
	"settings.autouv": "Otomatik UV",
	"settings.autouv.desc": "Otomatik UV'yi varsayılan olarak etkinleştir",
	"settings.create_rename": "Yeni Öğeyi Yeniden Adlandır",
	"settings.create_rename.desc": "Yeni öğe veya grup oluştururken isim alanına odaklan",
	"settings.edit_size": "Izgara Çözünürlüğü",
	"settings.edit_size.desc": "Öğelerin yaslandığı ızgaranın çözünürlüğü",
	"settings.shift_size": "Shift Çözünürlüğü",
	"settings.shift_size.desc": "Shift tuşunu basılı tutarken ızgaranın çözünürlüğü",
	"settings.ctrl_size": "Control Çözünürlüğü",
	"settings.ctrl_size.desc": "Control tuşunu basılı tutarken ızgaranın çözünürlüğü",
	"settings.negative_size": "Negatif Boyut",
	"settings.negative_size.desc": "Yeniden boyutlandırma aracının negatif boyutlar kullanmasına izin ver",
	"settings.minifiedout": "Küçültülmüş Dışa Aktarma",
	"settings.minifiedout.desc": "JSON dosyalarını tek satırda yaz",
	"settings.export_groups": "Java blok/öğe modellerinde Grupları Dışa Aktar",
	"settings.export_groups.desc": "Java blok veya öğe modeli JSON dosyalarında grupları kaydet",
	"settings.credit": "Katkıda Bulunan Yorumu",
	"settings.credit.desc": "Dışa aktarılan dosyalara bir katkıda bulunan yorumu ekle",
	"settings.default_path": "Varsayılan Minecraft Dokuları Yolu",
	"settings.default_path.desc": "Blockbench'in varsayılan dokuları yüklediği klasör",
	"settings.image_editor": "Görsel Düzenleyici",
	"settings.image_editor.desc": "Dokuları düzenlemek için varsayılan görsel düzenleyici",
	"category.navigate": "Navigasyon",
	"category.tools": "Araçlar",
	"category.file": "Dosya",
	"category.blockbench": "Blockbench",
	"category.edit": "Düzenle",
	"category.transform": "Dönüştür",
	"category.view": "Görünüm",
	"category.display": "Görüntüleme Ayarları",
	"category.textures": "Dokular",
	"category.misc": "Çeşitli",
	"keybind.preview_select": "Seç",
	"keybind.preview_rotate": "Görünümü Döndür",
	"keybind.preview_drag": "Görünümü Sürükle",
	"keybind.confirm": "Onayla",
	"keybind.cancel": "İptal",
	"action.slider_inflate": "Şişir",
	"action.slider_inflate.desc": "UV'yi değiştirmeden küpleri tüm yönlerde şişir",
	"action.slider_brush_size": "Boyut",
	"action.slider_brush_size.desc": "Piksel cinsinden fırçanın yarıçapı",
	"action.slider_brush_opacity": "Opaklık",
	"action.slider_brush_opacity.desc": "0'dan 255'e kadar fırçanın opaklığı",
	"action.slider_brush_softness": "Yumuşaklık",
	"action.slider_brush_softness.desc": "Yüzde olarak fırçanın yumuşaklığı",
	"action.uv_slider_pos_x": "Yatay Taşı",
	"action.uv_slider_pos_x.desc": "Tüm seçili UV yüzlerini yatay olarak taşı",
	"action.uv_slider_pos_y": "Dikey Taşı",
	"action.uv_slider_pos_y.desc": "Tüm seçili UV yüzlerini dikey olarak taşı",
	"action.uv_slider_size_x": "Yatay Boyut",
	"action.uv_slider_size_x.desc": "Tüm seçili UV yüzlerini yatay olarak yeniden boyutlandır",
	"action.uv_slider_size_y": "Dikey Boyut",
	"action.uv_slider_size_y.desc": "Tüm seçili UV yüzlerini dikey olarak yeniden boyutlandır",
	"action.vertex_snap_mode": "Yaslama Modu",
	"action.vertex_snap_mode.desc": "Tepe Noktası Yaslamanın öğeleri seçili konuma taşıyıp taşımadığını veya yeniden boyutlandırıp boyutlandırmadığını seçin",
	"action.move_tool": "Taşı",
	"action.move_tool.desc": "Öğeleri seçme ve taşıma aracı",
	"action.resize_tool": "Yeniden Boyutlandır",
	"action.resize_tool.desc": "Öğeleri seçme ve yeniden boyutlandırma aracı",
	"action.brush_tool": "Boya Fırçası",
	"action.brush_tool.desc": "Dokular üzerinde çizim yapmak için renkli fırça",
	"action.vertex_snap_tool": "Tepe Noktası Yaslama",
	"action.vertex_snap_tool.desc": "İki tepe noktasını birleştirerek bir küpü başka bir küpe taşı",
	"action.swap_tools": "Araçları Değiştir",
	"action.swap_tools.desc": "Taşıma ve yeniden boyutlandırma aracı arasında geçiş yap",
	"action.project_window": "Proje...",
	"action.project_window.desc": "Modelinizin meta verilerini düzenleyebileceğiniz proje penceresini açar",
	"action.open_model": "Model Aç",
	"action.open_model.desc": "Bilgisayarınızdan bir model dosyası açın",
	"action.extrude_texture": "Dışa Çıkarılmış Doku",
	"action.extrude_texture.desc": "Bir dokuyu uzatarak bir model oluşturun",
	"action.export_blockmodel": "Blok/Öğe Modelini Dışa Aktar",
	"action.export_blockmodel.desc": "Bir Minecraft Java Sürümü bloğunu veya öğe modelini dışa aktarın",
	"action.export_optifine_part": "OptiFine Parçasını Dışa Aktar",
	"action.export_optifine_part.desc": "Bir OptiFine varlık modeli için tek bir parçayı dışa aktarın",
	"action.export_optifine_full": "OptiFine JEM'i Dışa Aktar",
	"action.export_optifine_full.desc": "Tam bir OptiFine varlık modelini dışa aktarın",
	"action.export_obj": "OBJ Modelini Dışa Aktar",
	"action.export_obj.desc": "Renderleme için bir Wavefront OBJ modelini dışa aktarın",
	"action.settings_window": "Ayarlar...",
	"action.settings_window.desc": "Blockbench ayarları diyaloğunu açın.",
	"action.plugins_window": "Eklentiler...",
	"action.plugins_window.desc": "Eklenti mağazası penceresini açın",
	"action.reset_layout": "Düzeni Sıfırla",
	"action.reset_layout.desc": "Düzeni Blockbench'in varsayılanına sıfırlayın",
	"action.load_plugin": "Dosyadan Eklenti Yükle",
	"action.load_plugin.desc": "Kaynak dosyasını içe aktararak bir eklenti yükleyin",
	"action.reload_plugins": "Eklentileri Yeniden Yükle",
	"action.reload_plugins.desc": "Tüm geliştirme eklentilerini yeniden yükleyin",
	"action.undo": "Geri Al",
	"action.undo.desc": "Son değişikliği geri alır",
	"action.redo": "Yinele",
	"action.redo.desc": "Son geri almayı geri döndürür",
	"action.copy": "Kopyala",
	"action.copy.desc": "Seçili seçimi, yüzü veya görüntüleme ayarlarını kopyalayın",
	"action.paste": "Yapıştır",
	"action.paste.desc": "Seçili seçimi, yüzü veya görüntüleme ayarlarını yapıştırın",
	"action.cut": "Kes",
	"action.cut.desc": "Seçili seçimi, yüzü veya görüntüleme ayarlarını kesin",
	"action.add_cube": "Küp Ekle",
	"action.add_cube.desc": "Yeni bir küp ekler",
	"action.add_group": "Grup Ekle",
	"action.add_group.desc": "Yeni bir grup veya kemik ekler",
	"action.outliner_toggle": "Daha Fazla Seçeneği Aç/Kapat",
	"action.outliner_toggle.desc": "Anahatta daha fazla seçenek için anahtarları açar/kapatır",
	"action.duplicate": "Çoğalt",
	"action.delete": "Sil",
	"action.sort_outliner": "Anahattı Sırala",
	"action.sort_outliner.desc": "Anahattı alfabetik olarak sıralayın",
	"action.select_window": "Seç...",
	"action.select_window.desc": "Özelliklerine göre öğeleri arayın ve seçin",
	"action.invert_selection": "Seçimi Ters Çevir",
	"action.invert_selection.desc": "Mevcut öğe seçimini ters çevirin",
	"action.select_all": "Tümünü Seç",
	"action.collapse_groups": "Grupları Daralt",
	"action.collapse_groups.desc": "Anahattaki tüm grupları daraltın",
	"action.scale": "Ölçeklendir...",
	"action.scale.desc": "Seçili öğeleri ölçeklendirin",
	"action.toggle_visibility": "Görünürlüğü Aç/Kapat",
	"action.toggle_visibility.desc": "Seçili öğelerin görünürlüğünü aç/kapat",
	"action.toggle_export": "Dışa Aktarmayı Aç/Kapat",
	"action.toggle_export.desc": "Seçili öğelerin dışa aktarma ayarını aç/kapat",
	"action.toggle_autouv": "Otomatik UV'yi Aç/Kapat",
	"action.toggle_autouv.desc": "Seçili öğelerin otomatik UV ayarını aç/kapat",
	"action.toggle_shade": "Gölgelendirmeyi Aç/Kapat",
	"action.toggle_shade.desc": "Seçili küplerin gölgelendirmesini aç/kapat",
	"action.rename": "Yeniden Adlandır",
	"action.rename.desc": "Seçili öğelerin veya grubun adını değiştirin",
	"action.add_display_preset": "Yeni Ön Ayar",
	"action.add_display_preset.desc": "Yeni bir görüntüleme ayarı ön ayarı ekleyin",
	"action.fullscreen": "Tam Ekran",
	"action.fullscreen.desc": "Tam ekran modunu açar/kapatır",
	"action.zoom_in": "Yakınlaştır",
	"action.zoom_in.desc": "Arayüzü büyütmek için yakınlaştırın",
	"action.zoom_out": "Uzaklaştır",
	"action.zoom_out.desc": "Arayüzü küçültmek için uzaklaştırın",
	"action.zoom_reset": "Yakınlaştırmayı Sıfırla",
	"action.zoom_reset.desc": "Yakınlaştırmayı varsayılan %100'e sıfırlayın",
	"action.reset_interface": "Arayüzü Sıfırla",
	"action.reset_interface.desc": "Arayüzün boyutunu ve konumlarını sıfırlayın",
	"action.screenshot_model": "Modelin Ekran Görüntüsünü Al",
	"action.screenshot_model.desc": "Mevcut açıdan modelin kırpılmış bir ekran görüntüsünü alın",
	"action.screenshot_app": "Uygulamanın Ekran Görüntüsünü Al",
	"action.screenshot_app.desc": "Tüm uygulamanın bir ekran görüntüsünü alın",
	"action.import_texture": "Doku İçe Aktar",
	"action.import_texture.desc": "Dosya sisteminizden bir veya daha fazla doku içe aktarın",
	"action.create_texture": "Doku Oluştur",
	"action.create_texture.desc": "Boş bir doku veya şablon dokusu oluşturun",
	"action.save_textures": "Dokuları Kaydet",
	"action.save_textures.desc": "Tüm kaydedilmemiş dokuları kaydedin",
	"action.animated_textures": "Animasyonlu Dokuları Oynat",
	"action.animated_textures.desc": "Animasyonlu dokuların önizlemesini oynatın ve duraklatın",
	"action.origin_to_geometry": "Merkezi Ortala",
	"action.origin_to_geometry.desc": "Merkez noktasını seçimin merkezine ayarlayın",
	"action.bone_reset_toggle": "Kemiği Sıfırla",
	"action.bone_reset_toggle.desc": "Kemiğin üst modelden küpleri görüntülemesini durdurun",
	"action.reload": "Blockbench'i Yeniden Yükle",
	"action.reload.desc": "Blockbench'i yeniden yükleyin. Bu, tüm kaydedilmemiş ilerlemeyi geçersiz kılacaktır",
	"menu.file": "Dosya",
	"menu.edit": "Düzenle",
	"menu.transform": "Dönüştür",
	"menu.display": "Görüntüle",
	"menu.view": "Görünüm",
	"menu.file.new": "Yeni",
	"menu.file.recent": "Son",
	"menu.file.import": "İçe Aktar",
	"menu.file.export": "Dışa Aktar",
	"menu.transform.rotate": "Döndür",
	"menu.transform.flip": "Çevir",
	"menu.transform.center": "Ortala",
	"menu.transform.properties": "Özellikler",
	"menu.display.preset": "Ön Ayarı Uygula",
	"menu.display.preset_all": "Ön Ayarı Her Yere Uygula",
	"menu.display.remove_preset": "Ön Ayarı Kaldır",
	"menu.view.zoom": "Yakınlaştır",
	"menu.view.background": "Arka Plan",
	"menu.view.screenshot": "Ekran Görüntüsü",
	"menu.cube.color": "İşaretleyici Rengi",
	"menu.cube.texture": "Doku",
	"menu.cube.texture.transparent": "Şeffaf",
	"menu.cube.texture.blank": "Boş",
	"menu.group.sort": "Sırala",
	"menu.texture.face": "Yüze Uygula",
	"menu.texture.file": "Dosya",
	"menu.texture.refresh": "Yenile",
	"menu.texture.change": "Dosyayı Değiştir",
	"menu.texture.folder": "Dosya Gezgini'nde Göster",
	"menu.texture.edit": "Düzenle",
	"menu.texture.export": "Farklı Kaydet",
	"menu.texture.save": "Kaydet",
	"menu.texture.properties": "Özellikler...",
	"menu.preview.background": "Arka Plan",
	"menu.preview.background.load": "Yükle",
	"menu.preview.background.position": "Pozisyon",
	"menu.preview.background.lock": "Kameraya Kilitle",
	"menu.preview.screenshot": "Ekran Görüntüsü",
	"menu.preview.perspective": "Perspektif",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Dörtlü Görünüm",
	"menu.preview.stop_drag": "Arka Plan Konumlandırmayı Durdur",
	"menu.uv.mapping.rotation": "Döndürme",
	"menu.uv.texture": "Doku",
	"cube.color.light_blue": "Açık Mavi",
	"cube.color.yellow": "Sarı",
	"cube.color.orange": "Turuncu",
	"cube.color.red": "Kırmızı",
	"cube.color.purple": "Mor",
	"cube.color.blue": "Mavi",
	"cube.color.green": "Yeşil",
	"cube.color.lime": "Limon Yeşili",
	"switches.visibility": "Görünürlük",
	"switches.export": "Dışa Aktar",
	"switches.autouv": "Otomatik UV",
	"panel.uv": "UV",
	"panel.display": "Görüntüle",
	"panel.textures": "Dokular",
	"panel.outliner": "Anahat",
	"uv_editor.title": "UV Düzenleyici",
	"uv_editor.all_faces": "Tümü",
	"uv_editor.no_faces": "Hiçbiri",
	"face.north": "Kuzey",
	"face.south": "Güney",
	"face.west": "Batı",
	"face.east": "Doğu",
	"face.up": "Yukarı",
	"face.down": "Aşağı",
	"direction.north": "Kuzey",
	"direction.south": "Güney",
	"direction.west": "Batı",
	"direction.east": "Doğu",
	"direction.top": "Üst",
	"direction.bottom": "Alt",
	"display.slot.third_right": "Üçüncü Şahıs Sağ",
	"display.slot.third_left": "Üçüncü Şahıs Sol",
	"display.slot.first_right": "Birinci Şahıs Sağ",
	"display.slot.first_left": "Birinci Şahıs Sol",
	"display.slot.head": "Kafa",
	"display.slot.ground": "Zemin",
	"display.slot.frame": "Çerçeve",
	"display.slot.gui": "Arayüz",
	"display.rotation": "Döndürme",
	"display.translation": "Çeviri",
	"display.scale": "Ölçek",
	"display.slot": "Yuva",
	"display.reference": "Referans Model",
	"display.reference.player": "Oyuncu",
	"display.reference.zombie": "Zombi",
	"display.reference.armor_stand": "Zırh Standı",
	"display.reference.baby_zombie": "Bebek Zombi",
	"display.reference.armor_stand_small": "Küçük Zırh Standı",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Gerilmiş Yay",
	"display.reference.block": "Blok",
	"display.reference.frame": "Eşya Çerçevesi",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Envanter",
	"display.reference.hud": "Arayüz",
	"display.preset.blank_name": "Lütfen bir isim girin",
	"display.preset.item": "Varsayılan Eşya",
	"display.preset.block": "Varsayılan Blok",
	"display.preset.handheld": "Varsayılan Silah",
	"display.preset.rod": "Varsayılan Olta",
	"dialog.continue": "Devam Et",
	"message.square_textures": "Dokular kare olmalıdır",
	"message.unsaved_texture.title": "Kaydedilmemiş Doku",
	"message.unsaved_texture.message": "Bu dokudaki tüm kaydedilmemiş değişiklikler kaybolacak. Devam etmek istiyor musunuz?",
	"action.vertex_snap_mode.move": "Taşı",
	"action.vertex_snap_mode.scale": "Ölçeklendir",
	"action.open_model_folder": "Model Klasörünü Aç",
	"action.open_model_folder.desc": "Modelin bulunduğu klasörü açar",
	"action.change_textures_folder": "Doku Konumunu Değiştir",
	"action.change_textures_folder.desc": "Tüm dokuların kaydedildiği klasörü değiştirin",
	"menu.texture.particle": "Parçacıklar için Kullan",
	"message.update_notification.title": "Güncelleme Yüklenemedi",
	"message.update_notification.message": "Yeni bir Blockbench sürümü mevcut. Güncellemek için lütfen ayarlardan Otomatik Güncellemeleri etkinleştirin!",
	"message.untextured": "Bu yüzeyin bir dokusu yok",
	"dialog.toolbar_edit.title": "Araç Çubuğunu Özelleştir",
	"keybindings.reset": "Sıfırla",
	"keybindings.clear": "Boşalt",
	"action.cube_counter": "Model İstatistikleri",
	"action.uv_rotation": "UV Döndürme",
	"action.uv_rotation.desc": "UV yüzünün döndürülmesi",
	"action.uv_grid": "UV Izgarası",
	"action.uv_grid.desc": "UV seçicinin yaslandığı ızgaranın çözünürlüğü",
	"action.uv_grid.auto": "Otomatik",
	"action.uv_maximize": "UV'yi Maksimize Et",
	"action.uv_maximize.desc": "Bu yüz için UV'yi tam dokuya ayarlar",
	"action.uv_auto": "Otomatik UV",
	"action.uv_auto.desc": "Bu yüzün UV boyutunu yüzün gerçek boyutuna ayarlar",
	"action.uv_rel_auto": "Göreceli Otomatik UV",
	"action.uv_rel_auto.desc": "Bu yüzün UV'sini gerçek yüzün konumuna ve boyutuna ayarlar",
	"action.uv_mirror_x": "UV'yi X'te Aynala",
	"action.uv_mirror_x.desc": "Bu yüzün UV'sini X ekseninde yansıtır",
	"action.uv_mirror_y": "UV'yi Y'de Aynala",
	"action.uv_mirror_y.desc": "Bu yüzün UV'sini Y ekseninde yansıtır",
	"action.uv_transparent": "Yüzü Kaldır",
	"action.uv_transparent.desc": "Mevcut yüzü kaldırır",
	"action.uv_reset": "Yüzü Sıfırla",
	"action.uv_reset.desc": "Mevcut yüzü sıfırlar",
	"action.cullface": "Görünmeyen Yüzü Gizle",
	"action.cullface.desc": "Modelin seçili tarafı kapalıysa bu yüz için renderlemeyi devre dışı bırakır",
	"action.auto_cullface": "Görünmeyen Yüz Gizlemeyi Etkinleştir",
	"action.auto_cullface.desc": "Bu yüz için görünmeyen yüz gizlemeyi kendisine ayarlar",
	"action.face_tint": "Tonlama",
	"action.face_tint.desc": "Mevcut yüz için tonlama seçeneğini etkinleştirir",
	"menu.toolbar.edit": "Araç Çubuğunu Özelleştir",
	"menu.toolbar.reset": "Araç Çubuğunu Sıfırla",
	"uv_editor.rotated": "Döndürüldü",
	"uv_editor.auto_cull": "Kendine Görünmeyen Yüz Gizle",
	"uv_editor.copied": "Yüz Kopyalandı",
	"uv_editor.pasted": "Yüz Yapıştırıldı",
	"uv_editor.copied_x": "%0 Yüz Kopyalandı",
	"uv_editor.reset": "Yüzü Sıfırla",
	"uv_editor.maximized": "Maksimize Edildi",
	"uv_editor.autouv": "Otomatik Boyut",
	"uv_editor.mirrored": "Aynalandı",
	"uv_editor.to_all": "Tüm Yüzlere Uygula",
	"uv_editor.transparent": "Şeffaf Yapıldı",
	"uv_editor.cullface_on": "Görünmeyen Yüz Gizleme Açık",
	"uv_editor.cullface_off": "Görünmeyen Yüz Gizleme Kapalı",
	"uv_editor.tint_on": "Tonlama Açık",
	"uv_editor.tint_off": "Tonlama Kapalı",
	"action.uv_apply_all": "Tüm Yüzlere Uygula",
	"action.uv_apply_all.desc": "Mevcut yüzün ayarlarını tüm yüzlere uygular",
	"message.image_editor_missing.title": "Varsayılan Resim Düzenleyici",
	"message.image_editor_missing.message": "Resim düzenleyicinizin yürütülebilir dosyasını seçin.",
	"message.image_editor_missing.detail": "Blockbench bilgisayarınızda bir resim düzenleyici bulamadı. Tercih ettiğiniz resim düzenleyicinin yürütülebilir dosyasını seçin.",
	"action.update_autouv": "Otomatik UV'yi Güncelle",
	"action.update_autouv.desc": "Seçili küplerin otomatik UV haritalamasını güncelleyin",
	"category.uv": "UV",
	"status_bar.saved": "Model kaydedildi",
	"status_bar.unsaved": "Kaydedilmemiş değişiklikler var",
	"action.move_up": "Yukarı Taşı",
	"action.move_up.desc": "Seçili öğeleri mevcut kamera açısına göre yukarı taşıyın",
	"action.move_down": "Aşağı Taşı",
	"action.move_down.desc": "Seçili öğeleri mevcut kamera açısına göre aşağı taşıyın",
	"action.move_left": "Sola Taşı",
	"action.move_left.desc": "Seçili öğeleri mevcut kamera açısına göre sola taşıyın",
	"action.move_right": "Sağa Taşı",
	"action.move_right.desc": "Seçili öğeleri mevcut kamera açısına göre sağa taşıyın",
	"action.move_forth": "İleri Taşı",
	"action.move_forth.desc": "Seçili öğeleri mevcut kamera açısına göre ileri taşıyın",
	"action.move_back": "Geri Taşı",
	"action.move_back.desc": "Seçili öğeleri mevcut kamera açısına göre geri taşıyın",
	"layout.color.wireframe": "Tel Kafes",
	"layout.color.wireframe.desc": "Tel kafes görünüm çizgileri",
	"action.add_animation": "Animasyon Ekle",
	"action.add_animation.desc": "Boş bir animasyon oluşturun",
	"action.load_animation_file": "Animasyonları İçe Aktar",
	"action.load_animation_file.desc": "Bir animasyon dosyasını içe aktarın",
	"action.play_animation": "Animasyonu Oynat",
	"action.play_animation.desc": "Seçili animasyonu önizleyin",
	"action.slider_keyframe_time": "Zaman Kodu",
	"action.slider_keyframe_time.desc": "Seçili anahtar karelerin zaman kodunu değiştirin",
	"timeline.rotation": "Döndürme",
	"timeline.position": "Pozisyon",
	"timeline.scale": "Ölçek",
	"menu.keyframe.quaternion": "Kuaternion",
	"panel.animations": "Animasyonlar",
	"panel.keyframe": "Anahtar Kare",
	"panel.keyframe.type": "Anahtar Kare (%0)",
	"generic.delete": "Sil",
	"generic.rename": "Yeniden Adlandır",
	"message.no_animation_selected": "Bunu yapmak için bir animasyon seçmelisiniz",
	"message.no_bone_selected": "Bunu yapmak için bir kemik seçmelisiniz",
	"message.duplicate_groups.title": "Yinelenen Kemik Adı",
	"message.duplicate_groups.message": "Bu kemiğin adı birden fazla kemikte mevcut. Bu sorunlara neden olabilir.",
	"action.delete_keyframes": "Anahtar Kareleri Sil",
	"action.delete_keyframes.desc": "Tüm seçili anahtar kareleri silin",
	"menu.animation": "Animasyon",
	"menu.animation.loop": "Döngü Modu",
	"menu.animation.override": "Geçersiz Kıl",
	"menu.animation.anim_time_update": "Animasyon Zamanı Güncellemesi",
	"message.display_skin_model.title": "Kaplama Modeli",
	"message.display_skin_model.message": "Kaplamanızın model türünü seçin",
	"message.display_skin_model.classic": "Klasik",
	"message.display_skin_model.slim": "İnce",
	"message.bone_material": "Kemik materyalini değiştir",
	"action.slider_animation_length": "Animasyon Uzunluğu",
	"action.slider_animation_length.desc": "Seçili animasyonun uzunluğunu değiştirin",
	"panel.variable_placeholders": "Değişken Yer Tutucuları",
	"status_bar.vertex_distance": "Mesafe: %0",
	"dialog.create_gif.title": "GIF Kaydet",
	"dialog.create_gif.length": "Uzunluk",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Animasyonu Oynat",
	"category.animation": "Animasyon",
	"action.record_model_gif": "GIF Kaydet...",
	"action.record_model_gif.desc": "Mevcut açıdan modelin animasyonlu bir GIF'ini kaydedin",
	"display.mirror": "Ayna",
	"data.separator": "Ayırıcı",
	"menu.preview.background.set_position": "Pozisyonu Ayarla",
	"dialog.toolbar_edit.hidden": "Gizli",
	"action.export_class_entity": "Java Varlığını Dışa Aktar",
	"action.export_class_entity.desc": "Varlık modelini bir Java sınıfı olarak dışa aktarın",
	"settings.seethrough_outline": "X-Işını Anahatları",
	"settings.seethrough_outline.desc": "Nesnelerin içinden anahatları göster",
	"mode.edit": "Düzenle",
	"mode.paint": "Boya",
	"mode.display": "Görüntüle",
	"mode.animate": "Animasyon",
	"status_bar.recording_gif": "Kaydediliyor",
	"status_bar.processing_gif": "İşleniyor",
	"settings.backup_retain": "Yedekleme Saklama Süresi",
	"settings.backup_retain.desc": "Blockbench'in eski yedekleri gün cinsinden ne kadar süreyle saklayacağını ayarlayın",
	"action.rotate_tool": "Döndür",
	"action.rotate_tool.desc": "Öğeleri seçme ve döndürme aracı",
	"action.fill_tool": "Boya Kovası",
	"action.fill_tool.desc": "Tüm yüzleri tek renkle doldurmak için boya kovası",
	"action.eraser": "Silgi",
	"action.eraser.desc": "Bir dokudaki renkleri şeffaflıkla değiştirmek için silgi aracı",
	"action.color_picker": "Renk Seçici",
	"action.color_picker.desc": "Dokunuzdaki piksellerin rengini seçme aracı",
	"switches.mirror": "UV'yi Aynala",
	"language_name": "Türkçe",
	"message.plugin_reload": "%0 yerel eklenti yeniden yüklendi",
	"settings.brightness": "Parlaklık",
	"settings.brightness.desc": "Önizlemenin parlaklığı. Varsayılan 50'dir",
	"menu.preview.perspective.reset": "Kamerayı Sıfırla",
	"action.fill_mode": "Doldurma Modu",
	"action.fill_mode.face": "Yüz",
	"action.fill_mode.color": "Renkler",
	"action.toggle_mirror_uv": "UV'yi Aynala",
	"action.toggle_mirror_uv.desc": "Seçili küplerin X ekseninde UV aynalamasını aç/kapat",
	"menu.texture.blank": "Dokusuz Yüzlere Uygula",
	"dialog.scale.select_overflow": "Taşmayı Seç",
	"action.action_control": "Eylem Kontrolü",
	"action.action_control.desc": "Mevcut herhangi bir eylemi arayın ve yürütün",
	"keybindings.recording": "Tuş Ataması Kaydediliyor",
	"keybindings.press": "Tuş atamanızı kaydetmek için bir tuşa veya tuş kombinasyonuna basın ya da ekranın herhangi bir yerine tıklayın.",
	"action.pivot_tool": "Merkez Noktası Aracı",
	"action.pivot_tool.desc": "Öğelerin ve kemiklerin merkez noktasını değiştirme aracı",
	"action.slider_animation_speed": "Oynatma Hızı",
	"action.slider_animation_speed.desc": "Yüzde olarak zaman çizelgesinin oynatma hızı",
	"action.previous_keyframe": "Önceki Anahtar Kare",
	"action.previous_keyframe.desc": "Önceki anahtar kareye atlayın",
	"action.next_keyframe": "Sonraki Anahtar Kare",
	"action.next_keyframe.desc": "Sonraki anahtar kareye atlayın",
	"message.outdated_client.title": "Eski İstemci",
	"message.outdated_client.message": "Bunu yapmak için lütfen Blockbench'in en son sürümüne güncelleyin.",
	"action.export_asset_archive": "Arşivi İndir",
	"action.export_asset_archive.desc": "Modeli ve içindeki tüm dokuları içeren bir arşivi indirin",
	"action.upload_sketchfab": "Sketchfab'e Yükle...",
	"message.sketchfab.name_or_token": "Lütfen Sketchfab jetonunuzu ve bir isim girin",
	"dialog.sketchfab_uploader.title": "Sketchfab Modeli Yükle",
	"dialog.sketchfab_uploader.token": "API Jetonu",
	"dialog.sketchfab_uploader.about_token": "Jeton, Blockbench'i Sketchfab hesabınıza bağlamak için kullanılır. Bunu %0 adresinde bulabilirsiniz",
	"dialog.sketchfab_uploader.name": "Model Adı",
	"dialog.sketchfab_uploader.description": "Açıklama",
	"dialog.sketchfab_uploader.tags": "Etiketler",
	"settings.sketchfab_token": "Sketchfab Jetonu",
	"settings.sketchfab_token.desc": "Blockbench'i Sketchfab hesabınıza yükleme yetkisi vermek için jeton",
	"panel.color": "Renk",
	"data.origin": "Merkez Noktası",
	"message.sketchfab.success": "Model başarıyla yüklendi",
	"message.sketchfab.error": "Model Sketchfab'e yüklenemedi",
	"settings.outliner_colors": "Anahat Renkleri",
	"settings.outliner_colors.desc": "Anahatta öğe ve grup renklerini görüntüle",
	"action.upload_sketchfab.desc": "Modelinizi Sketchfab'e yükleyin",
	"action.element_colors": "Küp Renkleri",
	"action.element_colors.desc": "Anahatta küp renklerini göster",
	"texture.error.file": "Dosya bulunamadı",
	"texture.error.parent": "Doku dosyası üst model tarafından sağlandı",
	"message.recover_backup.title": "Modelleri Kurtar",
	"message.recover_backup.message": "Blockbench kaydetmeden kapatıldı. Modelleri kurtarmak istiyor musunuz?",
	"message.invalid_session.title": "Geçersiz Oturum Jetonu",
	"message.invalid_session.message": "Katılmaya çalıştığınız oturumun süresi dolmuş veya sağlanan jeton geçersiz.",
	"dialog.create_texture.power": "2'nin Katı Boyutu",
	"dialog.create_gif.turn": "Döner Tabla Hızı",
	"action.edit_session": "Oturumu Düzenle...",
	"action.edit_session.desc": "Diğer kullanıcılarla işbirliği yapmak için bir düzenleme oturumuna bağlanın",
	"action.reset_keyframe": "Anahtar Kareyi Sıfırla",
	"action.reset_keyframe.desc": "Seçili anahtar karelerin tüm değerlerini sıfırlayın",
	"dialog.edit_session.title": "Oturumu Düzenle",
	"edit_session.username": "Kullanıcı Adı",
	"edit_session.token": "Jeton",
	"edit_session.about": "Düzenleme Oturumları, internet üzerinden modeller üzerinde işbirliği yapmak için kullanılabilir. Bir oturum oluşturun, jetonu kopyalayın ve arkadaşlarınıza gönderin, onlar da katılmak için kullanabilir.",
	"edit_session.join": "Oturuma Katıl",
	"edit_session.create": "Oturum Oluştur",
	"edit_session.quit": "Oturumdan Ayrıl",
	"edit_session.joined": "%0 oturuma katıldı",
	"edit_session.left": "%0 oturumdan ayrıldı",
	"edit_session.quit_session": "Mevcut oturumdan ayrıldı",
	"edit_session.status": "Durum",
	"edit_session.hosting": "Barındırılıyor",
	"edit_session.connected": "Bir oturuma bağlı",
	"dialog.sketchfab_uploader.private": "Özel (Pro)",
	"dialog.sketchfab_uploader.password": "Şifre (Pro)",
	"action.uv_select_all": "Tümünü Seç",
	"action.uv_select_all.desc": "UV diyaloğundaki tüm yüzleri seçin",
	"panel.chat": "Sohbet",
	"edit_session.welcome": "%0 tarafından oluşturulan bu oturuma hoş geldiniz",
	"dialog.yes": "Evet",
	"dialog.no": "Hayır",
	"generic.remove": "Kaldır",
	"generic.download": "İndir",
	"generic.search": "Ara",
	"dates.today": "Bugün",
	"dates.yesterday": "Dün",
	"dates.this_week": "Bu Hafta",
	"dates.weeks_ago": "%0 hafta önce",
	"mode.start.new": "Yeni",
	"mode.start.recent": "Son Açılanlar",
	"format.free": "Genel Model",
	"format.free.desc": "Kısıtlama olmadan modelleme. Oyun motorları, render vs. için.",
	"format.java_block": "Java Blok/Öğe",
	"format.java_block.desc": "Minecraft Java Sürümü için blok veya öğe modeli.",
	"format.bedrock": "Bedrock Varlığı",
	"format.bedrock.desc": "Minecraft Bedrock Sürümü için varlık ve öğe bağlantı modeli",
	"format.bedrock_old": "Bedrock Eski Modeli",
	"format.bedrock_old.desc": "1.12 öncesi Minecraft Bedrock Sürümü varlık modeli",
	"format.modded_entity": "Modlu Varlık",
	"format.modded_entity.desc": "Minecraft modları için varlık modeli. .java sınıf dosyası olarak dışa aktarılabilir.",
	"format.optifine_entity": "OptiFine Varlığı",
	"format.optifine_entity.desc": "OptiFine modu için özel varlık modeli",
	"keys.mouse": "Fare Tuşu %0",
	"message.cleared_blank_faces.title": "Boş Yüzler",
	"message.cleared_blank_faces.message": "Blockbench, dokusu olmayan %0 küp buldu. Bu öğeleri kaldırmak istiyor musunuz?",
	"message.wireframe.enabled": "Tel kafes görünümü etkinleştirildi",
	"message.wireframe.disabled": "Tel kafes görünümü devre dışı bırakıldı",
	"dialog.convert_project.title": "Projeyi Dönüştür",
	"dialog.create_texture.double_use": "Çoklu Doku Kullanımını Koru",
	"dialog.model_stats.title": "Model İstatistikleri",
	"dialog.model_stats.cubes": "Küpler",
	"dialog.model_stats.locators": "Konumlayıcılar",
	"dialog.model_stats.groups": "Gruplar",
	"dialog.model_stats.vertices": "Tepe Noktaları",
	"dialog.model_stats.faces": "Yüzler",
	"settings.username": "Kullanıcı adı",
	"settings.username.desc": "Düzenleme oturumları için kullanıcı adı",
	"settings.painting_grid": "Boya Izgarası",
	"settings.painting_grid.desc": "Boya modunda dokulu öğeler üzerinde ızgara göster",
	"action.convert_project": "Projeyi Dönüştür",
	"action.convert_project.desc": "Mevcut projeyi başka bir model formatı için bir projeye dönüştürür",
	"action.close_project": "Projeyi Kapat",
	"action.close_project.desc": "Şu anda açık olan projeyi kapatır",
	"action.export_bedrock": "Bedrock Geometrisini Dışa Aktar",
	"action.export_bedrock.desc": "Modeli bir Bedrock Sürümü geometri dosyası olarak dışa aktarın.",
	"action.save_project": "Projeyi Kaydet",
	"action.save_project.desc": "Mevcut modeli bir proje dosyası olarak kaydeder",
	"action.save_project_as": "Projeyi Farklı Kaydet",
	"action.save_project_as.desc": "Mevcut modeli yeni bir konumda bir proje dosyası olarak kaydeder",
	"action.export_over": "Modeli Kaydet",
	"action.export_over.desc": "Modeli, dokuları ve animasyonları dosyaların üzerine yazarak kaydeder",
	"action.add_locator": "Konumlayıcı Ekle",
	"action.add_locator.desc": "Parçacıkların, tasmaların vb. konumlarını kontrol etmek için yeni bir konumlayıcı ekler",
	"action.uv_turn_mapping": "Haritalamayı Çevir",
	"action.uv_turn_mapping.desc": "UV haritalamasını 90 derece çevirin",
	"action.remove_blank_faces": "Boş Yüzleri Kaldır",
	"action.remove_blank_faces.desc": "Seçimin dokusuz tüm yüzlerini siler",
	"web.download_app": "Uygulamayı İndir",
	"uv_editor.turned": "Haritalama Çevrildi",
	"display.reference.crossbow": "Gerilmiş Arbalet",
	"dialog.settings.search_results": "Arama Sonuçları",
	"settings.animation_snap": "Animasyon Yaslama",
	"settings.animation_snap.desc": "Animasyon zaman çizelgesindeki anahtar kareler için saniyedeki adım cinsinden varsayılan yaslama aralığı. Bu, animasyon başına da değiştirilebilir. Varsayılan değer 24'tür.",
	"action.import_optifine_part": "OptiFine Parçasını İçe Aktar",
	"action.import_optifine_part.desc": "OptiFine için bir varlık parçası modelini içe aktarın",
	"data.locator": "Konumlayıcı",
	"mode.start.no_recents": "Son açılan model yok",
	"panel.element": "Öğe",
	"panel.element.position": "Pozisyon",
	"panel.element.size": "Boyut",
	"panel.element.origin": "Merkez Noktası",
	"panel.element.rotation": "Döndürme",
	"message.canvas_limit_error.title": "Tuval Sınırı Hatası",
	"message.canvas_limit_error.message": "Biçim, tuvali 48 birimle sınırladığı için eylem doğru bir şekilde gerçekleştirilemedi. Bunu önlemek için merkez noktasını kaydırın.",
	"data.effect": "Efekt",
	"generic.name": "İsim",
	"settings.recent_projects": "Son Model Sınırı",
	"settings.recent_projects.desc": "Hatırlanacak maksimum son model sayısı",
	"settings.volume": "Ses Seviyesi",
	"settings.volume.desc": "Animasyonlardaki ses efektleri için ses kontrolü",
	"action.clear_timeline": "Zaman Çizelgesini Temizle",
	"action.clear_timeline.desc": "Zaman çizelgesinden seçilmemiş tüm kemikleri temizleyin",
	"action.select_effect_animator": "Efektleri Canlandır",
	"action.select_effect_animator.desc": "Ses ve parçacık efektleri eklemek için zaman çizelgesini açar",
	"action.timeline_focus": "Kanalları Filtrele",
	"action.timeline_focus.desc": "Zaman çizelgesinde görüntülenecek animasyon kanallarını seçin",
	"timeline.particle": "Parçacık",
	"timeline.sound": "Ses",
	"timeline.effects": "Efektler",
	"data.format": "Biçim",
	"format.optifine_part": "OptiFine Parçası",
	"format.optifine_part.desc": "OptiFine varlık modelleri için JPM parçası",
	"action.reverse_keyframes": "Anahtar Kareleri Ters Çevir",
	"action.reverse_keyframes.desc": "Seçili anahtar karelerin sırasını tersine çevirin",
	"generic.help": "Yardım",
	"message.removed_faces": "%0 yüz kaldırıldı",
	"dialog.sketchfab_uploader.draft": "Taslak",
	"action.slider_pos": "Pozisyon %0",
	"action.slider_pos.desc": "Öğeleri %0 ekseninde taşı",
	"action.slider_size": "Boyut %0",
	"action.slider_size.desc": "Öğeleri %0 ekseninde yeniden boyutlandır",
	"action.slider_rotation": "Döndürme %0",
	"action.slider_rotation.desc": "Öğeleri %0 ekseninde döndür",
	"action.slider_origin": "Merkez %0",
	"action.slider_origin.desc": "Merkezi %0 ekseninde taşı",
	"action.rotate_cw": "%0'ı +90 Döndür",
	"action.rotate_cw.desc": "Seçili öğeleri %0 ekseninde 90° döndürün",
	"action.rotate_ccw": "%0'ı -90 Döndür",
	"action.rotate_ccw.desc": "Seçili öğeleri %0 ekseninde -90° döndürün",
	"action.flip": "%0'ı Çevir",
	"action.flip.desc": "Seçili öğeleri %0 ekseninde çevirin",
	"action.center": "%0'ı Ortala",
	"action.center.desc": "Seçili öğeleri %0 ekseninde ortalayın",
	"action.bring_up_all_animations": "Tüm Animatörleri Yukarı Getir",
	"panel.bone": "Kemik",
	"data.color": "Renk",
	"generic.export": "Dışa Aktar",
	"generic.none": "Hiçbiri",
	"status_bar.recording": "Zaman atlamalı kayıt yapılıyor",
	"message.add_to_palette": "Palete eklendi",
	"message.size_modifiers": "Daha küçük artışlarla dönüştürmek için Ctrl veya Shift tuşunu basılı tutun.",
	"message.timelapse_start": "Zaman atlamalı kayıt başladı",
	"message.timelapse_stop": "Zaman atlamalı kayıt durdu",
	"message.import_palette.replace_palette": "Eski paleti değiştir",
	"message.import_palette.threshold": "Birleştirme Eşiği",
	"dialog.timelapse.interval": "Aralık (Saniye)",
	"dialog.timelapse.source": "Kaynak",
	"dialog.timelapse.source.interface": "Arayüz",
	"dialog.timelapse.source.locked": "Kilitli Açı",
	"dialog.timelapse.destination": "Hedef Klasör",
	"layout.color.checkerboard": "Dama Tahtası",
	"layout.color.checkerboard.desc": "Tuval ve UV düzenleyici arka planı",
	"layout.font.code": "Kod Yazı Tipi",
	"layout.css": "Özel CSS",
	"settings.category.paint": "Boya",
	"settings.deactivate_size_limit": "Boyut Sınırını Devre Dışı Bırak",
	"settings.deactivate_size_limit.desc": "Belirli model formatları için boyut sınırını devre dışı bırakın. UYARI: Bu, geçersiz modellere neden olabilir.",
	"settings.brush_opacity_modifier": "Fırça Opaklık Değiştirici",
	"settings.brush_opacity_modifier.desc": "Bir stylus kullanırken fırça opaklığını değiştirin",
	"settings.brush_size_modifier": "Fırça Boyutu Değiştirici",
	"settings.brush_size_modifier.desc": "Bir stylus kullanırken fırça boyutunu değiştirin",
	"settings.brush_modifier.pressure": "Basınç",
	"settings.brush_modifier.tilt": "Eğim",
	"category.color": "Renk",
	"action.import_theme": "Tema İçe Aktar",
	"action.export_theme": "Tema Dışa Aktar",
	"action.export_theme.desc": "Mevcut ayarlara göre bir tema dosyası oluşturun",
	"action.slider_color_h": "Ton",
	"action.slider_color_s": "Doygunluk",
	"action.slider_color_v": "Değer",
	"action.add_to_palette": "Palete Ekle",
	"action.add_to_palette.desc": "Seçili rengi renk paletine ekleyin",
	"action.import_palette": "Palet İçe Aktar",
	"action.import_palette.desc": "Bir palet dosyasını içe aktarın",
	"action.export_palette": "Palet Dışa Aktar",
	"action.export_palette.desc": "Paleti bir .GPL dosyası olarak dışa aktarın",
	"action.generate_palette": "Palet Oluştur...",
	"action.generate_palette.desc": "Bir dokudan palet oluşturun",
	"action.sort_palette": "Paleti Sırala",
	"action.sort_palette.desc": "Paletteki tüm renkleri renge ve parlaklığa göre sıralayın",
	"action.timelapse": "Zaman Atlamalı Kayıt...",
	"action.timelapse.desc": "Modelleme sürecinizin bir zaman atlamalı kaydını yapın",
	"action.add_keyframe": "Anahtar Kare Ekle",
	"action.add_keyframe.desc": "Seçili animatöre bir anahtar kare ekleyin",
	"action.bring_up_all_animations.desc": "Tüm değiştirilmiş animatörleri zaman çizelgesine getirir",
	"timeline.timeline": "Talimatlar",
	"menu.palette.load.default": "Varsayılan",
	"generic.import": "İçe Aktar",
	"settings.brush_modifier.none": "Hiçbiri",
	"action.export_entity": "Bedrock Varlığını Dışa Aktar",
	"action.export_entity.desc": "Modeli Minecraft Bedrock Sürümü için bir varlık modeli olarak dışa aktarın",
	"settings.highlight_cubes": "Öğeleri Vurgula",
	"settings.highlight_cubes.desc": "Üzerlerine geldiğinizde veya seçtiğinizde öğeleri vurgulayın",
	"action.add_marker": "İşaretleyici Ayarla",
	"action.add_marker.desc": "Bir zaman çizelgesi işaretleyicisi ayarlayın",
	"timeline.pre_effect_script": "Betik",
	"format.skin": "Minecraft Kaplaması",
	"format.skin.desc": "Oyuncu ve varlık kaplamalarını düzenle",
	"message.sketchfab.setup_guide": "Sketchfab'de modelleri nasıl kuracağınızı öğrenmek ister misiniz? %0'ı okuyun",
	"dialog.skin.title": "Minecraft Kaplaması Oluştur",
	"dialog.skin.model": "Model",
	"action.toggle_skin_layer": "Kaplama Katmanını Aç/Kapat",
	"action.toggle_skin_layer.desc": "Kaplama modelinin şapka ve giysi katmanını aç/kapat",
	"action.gui_light": "Arayüz Işığı",
	"action.gui_light.desc": "Envanterde öğenin aydınlatılma şeklini seçin",
	"action.gui_light.side": "Yan Işık",
	"action.gui_light.front": "Ön Işık",
	"action.move_keyframe_back": "Anahtar Kareleri Geri Taşı",
	"action.move_keyframe_forth": "Anahtar Kareleri İleri Taşı",
	"menu.help": "Yardım",
	"menu.help.discord": "Discord Sunucusu",
	"menu.help.report_issue": "Sorun Bildir",
	"menu.help.plugin_documentation": "Eklenti API Belgeleri",
	"menu.help.search_action": "Eylem Ara ve Çalıştır",
	"menu.help.donate": "Bağış Yap",
	"menu.help.about": "Hakkında...",
	"menu.preview.background.clipboard": "Panodan Yükle",
	"dialog.ignore": "Yoksay",
	"generic.unset": "Ayarlanmamış",
	"message.invalid_builtin_parent.title": "Geçersiz Dahili Üst Öğe",
	"message.invalid_builtin_parent.message": "Geçerli bir modeli dışa aktarmak için geçersiz üst model '%0' bağlantısı kaldırıldı.",
	"dialog.resize_texture.fill": "İle doldur",
	"dialog.resize_texture.fill.transparent": "Şeffaf",
	"dialog.resize_texture.fill.color": "Renk",
	"dialog.resize_texture.fill.repeat": "Tekrarla",
	"dialog.scale.element_pivot": "Öğe Merkezi",
	"dialog.scale.selection_center": "Seçim Merkezi",
	"dialog.create_gif.length_mode": "Uzunluk Modu",
	"dialog.create_gif.length_mode.seconds": "Saniye",
	"dialog.create_gif.length_mode.frames": "Kare",
	"dialog.create_gif.length_mode.animation": "Animasyon Uzunluğu",
	"dialog.create_gif.length_mode.turntable": "Döner Tabla Dönüşü",
	"dialog.save_angle.projection": "Projeksiyon",
	"dialog.save_angle.projection.perspective": "Perspektif",
	"dialog.save_angle.projection.orthographic": "Ortografik",
	"dialog.sketchfab_uploader.animations": "Animasyonlar",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Arayüz",
	"settings.preview_checkerboard": "Önizleme Dama Tahtası",
	"settings.preview_checkerboard.desc": "Önizlemenin arkasındaki dama tahtası arka planını aç/kapat",
	"settings.uv_checkerboard": "UV Düzenleyici Dama Tahtası",
	"settings.uv_checkerboard.desc": "UV düzenleyicinin arkasındaki dama tahtası arka planını aç/kapat",
	"category.paint": "Boya",
	"action.fill_mode.color_connected": "Bağlı Renkler",
	"action.draw_shape_type": "Şekil Tipi",
	"action.draw_shape_type.rectangle": "Dikdörtgen",
	"action.draw_shape_type.rectangle_h": "Dikdörtgen (İçi Boş)",
	"action.draw_shape_type.ellipse": "Elips",
	"action.draw_shape_type.ellipse_h": "Elips (İçi Boş)",
	"action.draw_shape_type.line": "Çizgi",
	"action.mirror_painting": "Ayna Boyama",
	"action.mirror_painting.description": "Boya darbelerinizi modelin diğer tarafına yansıtın",
	"action.lock_alpha": "Alfa Kanalını Kilitle",
	"action.lock_alpha.description": "Tüm piksellerin şeffaflığını kilitle",
	"action.draw_shape_tool": "Şekil Çiz",
	"action.draw_shape_tool.desc": "Dokular üzerinde basit şekiller çizme aracı",
	"action.export_gltf": "glTF Modelini Dışa Aktar",
	"action.export_gltf.desc": "Paylaşım ve renderleme için modeli ve animasyonları glTF dosyası olarak dışa aktarın",
	"action.transform_space": "Dönüşüm Alanı",
	"action.transform_space.desc": "Öğeler ve kemikler için varsayılan dönüşüm alanı",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Yerel",
	"action.toggle_camera_projection": "Kamera Projeksiyonunu Aç/Kapat",
	"action.toggle_camera_projection.desc": "Kamera projeksiyonunu perspektif ve ortografik arasında değiştirin",
	"action.load_camera_angle": "Kamera Açısı: %0",
	"action.load_camera_angle.desc": "'%0' kamera açısını yükleyin",
	"action.slider_face_tint": "Tonlama İndeksi",
	"action.slider_face_tint.desc": "Mevcut yüzün tonlama indeksini ayarlayın. -1 ayarlanmamış demektir.",
	"menu.help.quickstart": "Hızlı Başlangıç Sihirbazı",
	"menu.help.developer": "Geliştirici",
	"menu.help.developer.dev_tools": "Geliştirici Araçlarını Aç",
	"menu.help.developer.reset_storage": "Fabrika Ayarlarına Sıfırla",
	"menu.help.developer.reset_storage.confirm": "Blockbench'i fabrika ayarlarına sıfırlamak istediğinizden emin misiniz? Bu, tüm özel ayarları, tuş atamalarını ve yüklü eklentileri silecektir.",
	"menu.help.developer.cache_reload": "Önbelleği Yeniden Yükle",
	"menu.preview.orthographic": "Ortografik",
	"menu.preview.save_angle": "Açıyı Kaydet...",
	"menu.preview.angle": "Açılar",
	"menu.preview.angle.initial": "Başlangıç Açısı",
	"menu.preview.maximize": "Maksimize Et",
	"uv_editor.copy_selection": "Seçimi Kopyala",
	"uv_editor.paste_selection": "Seçimi Yapıştır",
	"uv_editor.copy_paste_tool.place": "Yerleştir",
	"uv_editor.copy_paste_tool.mirror_x": "X'i Aynala",
	"uv_editor.copy_paste_tool.mirror_y": "Y'yi Aynala",
	"uv_editor.copy_paste_tool.rotate": "90 Derece Döndür",
	"dialog.project.modded_entity_version": "Dışa Aktarma Sürümü",
	"dialog.save_angle.position": "Kamera Pozisyonu",
	"dialog.save_angle.target": "Odak Noktası",
	"dialog.skin.pose": "Poz",
	"layout.color.frame": "Pencere Çerçevesi",
	"layout.color.frame.desc": "Pencerenin kenarlığı ve başlık çubuğu",
	"settings.large_grid_size": "Blok Izgara Boyutu",
	"settings.large_grid_size.desc": "Blok ızgarasının boyutu",
	"action.load_plugin_from_url": "URL'den Eklenti Yükle",
	"action.load_plugin_from_url.desc": "URL'yi belirterek bir sunucudan eklenti yükleyin",
	"action.cube_counter.desc": "Mevcut öğe sayısını ve diğer istatistikleri görüntüler",
	"action.unlock_everything": "Tüm Kilitleri Aç",
	"action.unlock_everything.desc": "Anahattaki tüm grupların ve öğelerin kilidini açın.",
	"action.load_palette": "Palet Yükle",
	"action.load_palette.desc": "Dahili veya kaydedilmiş palet ön ayarlarından birini yükleyin",
	"action.toggle_locked": "Kilidi Aç/Kapat",
	"action.toggle_locked.desc": "Seçili öğelerin kilitli olup olmadığını aç/kapat",
	"action.apply_display_preset": "Ön Ayarı Uygula",
	"action.apply_display_preset.desc": "Varsayılan veya özel bir görüntüleme ayarı ön ayarı uygulayın",
	"action.apply_display_preset.here": "Bu Yuvaya Uygula",
	"action.apply_display_preset.everywhere": "Tüm Yuvalara Uygula",
	"action.resolve_keyframe_expressions": "Anahtar Kareyi Çöz",
	"action.resolve_keyframe_expressions.desc": "Seçili anahtar karelerin matematiksel ifadelerini çözer",
	"action.fold_all_animations": "Tüm Animatörleri Katla",
	"menu.palette.load.empty": "Boş",
	"switches.lock": "Kilit",
	"settings.render_sides": "Yüzeyleri İşle",
	"settings.render_sides.desc": "Bir yüzün hangi tarafının işleneceğini seçin",
	"settings.render_sides.auto": "Otomatik",
	"settings.render_sides.front": "Dış",
	"settings.render_sides.double": "İç ve Dış",
	"generic.enable": "Etkinleştir",
	"generic.disable": "Devre Dışı Bırak",
	"generic.redacted": "Sansürlendi",
	"dialog.select_texture.import_all": "Tümünü İçe Aktar",
	"dialog.skin.layer_template": "Katman Dokusu",
	"about.version.up_to_date": "Güncel",
	"about.version.update_available": "Sürüm %0 mevcut",
	"settings.category.application": "Uygulama",
	"settings.streamer_mode": "Yayıncı Modu",
	"settings.streamer_mode.desc": "Son modeller gibi hassas bilgileri gizler",
	"settings.automatic_updates": "Otomatik Güncellemeler",
	"settings.automatic_updates.desc": "Yeni sürümleri otomatik olarak indirin ve Blockbench'i güncel tutun",
	"action.rotation_space": "Döndürme Alanı",
	"action.focus_on_selection": "Görünümü Seçime Odakla",
	"action.focus_on_selection.desc": "Kamerayı mevcut seçimin merkezine bakacak şekilde hizalayın",
	"action.jump_to_timeline_start": "Animasyon Başlangıcına Git",
	"action.jump_to_timeline_end": "Animasyon Sonuna Git",
	"menu.help.updating": "Güncelleniyor (%0%)",
	"menu.help.update_failed": "Güncelleme Başarısız",
	"menu.animation.loop.once": "Bir Kez Oynat",
	"menu.animation.loop.hold": "Son Karede Tut",
	"menu.animation.loop.loop": "Döngü",
	"interface.streamer_mode_on": "Yayıncı Modu Etkin",
	"generic.reset": "Sıfırla",
	"generic.restore": "Geri Yükle",
	"keys.mousewheel": "Fare Tekerleği",
	"message.delete_animation.title": "Animasyonu Sil",
	"message.delete_animation.message": "Animasyon Blockbench'ten kaldırıldı. Animasyonu kaydedildiği dosyadan da silmek istiyor musunuz?",
	"message.no_animation_to_import": "İçe aktarılacak animasyon yok",
	"dialog.material_instances.title": "Malzeme Örnekleri",
	"dialog.animation_import.title": "İçe Aktarılacak Animasyonları Seç",
	"dialog.create_texture.padding": "Doldurma",
	"settings.fov": "Görüş Alanı (FOV)",
	"settings.fov.desc": "Kamera Görüş Alanı. Varsayılan 45'tir",
	"settings.minify_bbmodel": "Küçültülmüş Proje Dosyaları",
	"settings.minify_bbmodel.desc": ".bbmodel dosyalarını tek satırda küçültülmüş olarak yaz",
	"action.edit_material_instances": "Malzeme Örneklerini Düzenle",
	"action.edit_material_instances.desc": "Bedrock blok geometrileri için malzeme örneği adlarını düzenleyin",
	"action.save_all_animations": "Tüm Animasyonları Kaydet",
	"action.save_all_animations.desc": "Şu anda yüklü olan tüm animasyonları kaydedin",
	"action.keyframe_interpolation": "İnterpolasyon",
	"action.keyframe_interpolation.desc": "Anahtar kare interpolasyon modunu seçin",
	"action.keyframe_interpolation.linear": "Doğrusal",
	"action.keyframe_interpolation.catmullrom": "Yumuşak",
	"action.timeline_focus.hide_empty": "Boş kanalları gizle",
	"menu.file.preferences": "Tercihler",
	"menu.animation.blend_weight": "Karışım Ağırlığı",
	"menu.animation.save": "Kaydet",
	"menu.animation.properties": "Özellikler...",
	"menu.animation.file": "Dosya",
	"menu.animation.snapping": "Yaslama",
	"menu.animation.open_location": "Dosya Gezgini'nde Göster",
	"panel.keyframe.add_data_point": "Anahtar Kare Veri Noktası Ekle",
	"panel.keyframe.remove_data_point": "Veri Noktasını Kaldır",
	"panel.keyframe.pre": "Önce",
	"panel.keyframe.post": "Sonra",
	"generic.all": "Tümü",
	"message.small_face_dimensions.title": "Uyumsuz Yüz Boyutları",
	"message.small_face_dimensions.message": "Seçim, bir yönde 1 birimden daha küçük yüzler içeriyor. Kutu UV haritalama sistemi, bu eşiğin altındaki tüm yüzleri 0 piksel genişliğinde kabul eder. Bu nedenle bu yüzlerdeki doku düzgün çalışmayabilir.",
	"message.small_face_dimensions.face_uv": "Mevcut format, küçük yüz boyutlarını işleyebilen yüz başına UV haritalarını destekler. Etkilenen küplere sağ tıklayın ve \"UV Modu\"nu \"Yüz Başına UV\" olarak değiştirin.",
	"dialog.plugins.outdated_client": "Blockbench'in daha yeni bir sürümünü gerektirir",
	"dialog.plugins.outdated_plugin": "Eklenti güncel değil ve bu Blockbench sürümüyle çalışmıyor",
	"settings.motion_trails": "Hareket İzleri",
	"settings.motion_trails.desc": "Animasyon düzenleyicide hareket izlerini göster",
	"settings.antialiasing": "Kenar Yumuşatma",
	"settings.antialiasing.desc": "Önizlemede kenar yumuşatmayı aç/kapat",
	"action.timeline_frame_back": "1 Kare Geri Git",
	"action.timeline_frame_forth": "1 Kare İleri Git",
	"panel.bone.ik": "Ters Kinematik (Deneysel)",
	"settings.particle_tick_rate": "Parçacık Tik Hızı",
	"settings.particle_tick_rate.desc": "Parçacık efektleri için saniyedeki tik cinsinden tik hızı. Varsayılan 30'dur",
	"action.lock_motion_trail": "Hareket İzini Kilitle",
	"action.lock_motion_trail.desc": "Hareket izini şu anda seçili olan gruba kilitleyin",
	"menu.animation_file.unload": "Dosyayı Boşalt",
	"data.null_object": "Boş Nesne",
	"status_bar.toggle_sidebar": "Kenar Çubuğunu Aç/Kapat",
	"message.load_plugin_failed.title": "Eklenti yüklenemedi",
	"message.load_plugin_failed.message": "Plugin.register() içinde belirtildiği gibi, eklentinin temel dosya adının eklenti kimliği `%0` ile eşleştiğinden emin olun.",
	"dialog.project.uv_mode": "UV Modu",
	"dialog.project.uv_mode.box_uv": "Kutu UV",
	"dialog.project.uv_mode.face_uv": "Yüz Başına UV",
	"dialog.project.texture_size": "Doku Boyutu",
	"dialog.animation_export.title": "Dışa Aktarılacak Animasyonları Seç",
	"dialog.create_texture.rearrange_uv": "UV'yi Yeniden Düzenle",
	"layout.color.subtle_text": "Hafif Metin",
	"layout.color.subtle_text.desc": "Daha az kontrasta sahip ikincil metin rengi",
	"settings.interface_scale": "Arayüz Ölçeği",
	"settings.interface_scale.desc": "Tüm Blockbench arayüzünün ölçeği",
	"settings.background_rendering": "Arka Plan İşleme",
	"settings.background_rendering.desc": "Pencere odaklanmamışken önizlemeyi güncelle",
	"settings.ctrl_shift_size": "Control + Shift Çözünürlüğü",
	"settings.ctrl_shift_size.desc": "Control ve shift tuşlarını basılı tutarken ızgaranın çözünürlüğü",
	"settings.hardware_acceleration": "Donanım Hızlandırma",
	"settings.hardware_acceleration.desc": "Renderleme görevlerini grafik kartına dış kaynak olarak verin",
	"action.explode_skin_model": "Kaplama Modelini Patlat",
	"action.explode_skin_model.desc": "Kapalı yüzleri düzenlemenizi sağlayan bir patlama görünümünü açar/kapatır",
	"action.export_minecraft_skin": "Minecraft Kaplamasını Dışa Aktar",
	"action.export_minecraft_skin.desc": "Minecraft kaplamasını bir PNG dokusu olarak dışa aktarın",
	"action.add_null_object": "Boş Nesne Ekle",
	"action.add_null_object.desc": "Yeni bir boş nesne ekler",
	"action.animated_texture_frame": "Animasyonlu Doku Karesi",
	"action.animated_texture_frame.desc": "Animasyonlu dokunun mevcut karesini ayarlayın",
	"action.export_animation_file": "Animasyonları Dışa Aktar...",
	"action.export_animation_file.desc": "Bir animasyon seçimini yeni bir dosyaya aktarın",
	"action.timeline_graph_editor": "Grafik Düzenleyiciyi Aç/Kapat",
	"action.timeline_graph_editor.desc": "Zaman çizelgesini grafik düzenleyici görünümü ve anahtar kare görünümü arasında değiştirin",
	"menu.file.recent.clear": "Son Dosyaları Temizle",
	"switches.shade": "Gölge",
	"generic.share": "Paylaş",
	"dates.minute": "%0 Dakika",
	"dates.minutes": "%0 Dakika",
	"dates.hour": "%0 Saat",
	"dates.hours": "%0 Saat",
	"dates.day": "%0 Gün",
	"dates.days": "%0 Gün",
	"dates.week": "%0 Hafta",
	"dates.weeks": "%0 Hafta",
	"dates.year": "%0 Yıl",
	"dates.years": "%0 Yıl",
	"message.installed_plugin": "%0 eklentisi başarıyla yüklendi",
	"message.installed_plugin_fail": "%0 eklentisi yüklenemedi",
	"dialog.share_model.title": "Modeli Paylaş",
	"dialog.share_model.expire_time": "Son Kullanma Süresi",
	"dialog.share_model.failed": "Model yüklenemedi",
	"action.import_java_block_model": "Java Blok/Öğe Modeli Ekle",
	"action.import_java_block_model.desc": "Mevcut modele bir json dosyasından bir Minecraft Java blok/öğe modeli ekleyin",
	"action.share_model": "Paylaş...",
	"action.share_model.desc": "Modelinizi paylaşmak için kısa bir bağlantı oluşturun",
	"action.import_project": "Projeyi İçe Aktar",
	"action.import_project.desc": "Başka bir projeyi bir .bbmodel dosyasından mevcut projeye aktarın",
	"dialog.toolbar_edit.hidden_tools": "Bazı araçlar mevcut modda, formatta veya durumda mevcut olmadıkları için gizlenmiş olabilir.",
	"settings.camera_near_plane": "Kamera Yakın Düzlemi",
	"settings.camera_near_plane.desc": "Nesnelerin işlendiği kameradan minimum mesafe. Daha yüksek değerler Z-çatışmasını azaltır. Varsayılan 1'dir.",
	"mode.start.keymap_preference.desc": "Blockbench'e yeniyseniz ve başka bir 3D programdan geliyorsanız, geçişi kolaylaştırmak için bir tuş haritası seçebilirsiniz. Daha sonra ayarlardan tuş haritasını veya bireysel tuş atamalarını değiştirebilirsiniz.",
	"message.load_keymap": "Bu tuş haritasını yüklemek istediğinizden emin misiniz? Bu, mevcut tuş atamalarınızın üzerine yazacaktır.",
	"message.keymap_loaded": "Tuş haritası yüklendi",
	"dialog.convert_project.current_format": "Mevcut Format",
	"dialog.create_texture.rearrange_uv.desc": "Her yüze dokuda kendi yerini vermek için yeni bir UV düzenlemesi oluşturun",
	"dialog.create_texture.power.desc": "Otomatik doku boyutunu 64 veya 128 gibi 2'nin katı bir değere kilitleyin. Bu, bazı render motorları tarafından gereklidir",
	"dialog.create_texture.double_use.desc": "İki öğeye zaten aynı UV alanı atanmışsa, yeni haritada da bu şekilde kalsın",
	"dialog.create_texture.padding.desc": "Şablonun ayrı parçaları arasına küçük bir doldurma ekleyin",
	"dialog.create_texture.resolution.desc": "Dokunun yüksekliği ve genişliği",
	"dialog.create_gif.color": "Arka Plan Rengi",
	"dialog.save_angle.zoom": "Yakınlaştırma",
	"dialog.skin.variant": "Varyant",
	"dialog.flip_animation.info": "Karşıt kemikler, adlarındaki 'sol' ve 'sağ' anahtar kelimeleriyle tanımlanır.",
	"dialog.export_private_settings.title": "Özel Ayarlar",
	"dialog.export_private_settings.message": "Dosyanız aşağıdaki özel bilgileri içeriyor: **%0**. Dosyayı başka biriyle paylaşmayı planlıyorsanız bu değerleri dışarıda bırakın.",
	"dialog.export_private_settings.keep": "Koru",
	"settings.timecode_frame_number": "Zaman Kodlarını Kare Numarası Olarak Görüntüle",
	"settings.timecode_frame_number.desc": "Zaman çizelgesindeki kesirli zaman kodlarını sentisaniye yerine kare numarası olarak görüntüle",
	"settings.animation_sample_rate": "Animasyon Örnekleme Hızı",
	"settings.animation_sample_rate.desc": "İlgili formatın yerel olarak desteklemediği eğriler için saniyedeki örnek cinsinden örnekleme hızı",
	"keybind.preview_zoom": "Görünümü Yakınlaştır",
	"action.gradient_tool": "Gradyan Aracı",
	"action.gradient_tool.desc": "Dokunuzda bir renk gradyanı oluşturun",
	"action.import_settings": "Ayarları İçe Aktar",
	"action.import_settings.desc": "Bir .bbsettings dosyasını içe aktarın",
	"action.export_settings": "Ayarları Dışa Aktar",
	"action.export_settings.desc": "Blockbench ayarlarını bir .bbsettings dosyası olarak dışa aktarın",
	"action.load_keymap": "Tuş Haritası Yükle",
	"action.load_keymap.default": "Varsayılan (Trackpad/Fare)",
	"action.load_keymap.mouse": "Varsayılan (Fare)",
	"action.load_keymap.default.desc": "Dizüstü bilgisayar trackpadlerinde kullanıma optimize edilmiş görünüm alanı gezinme kontrolleri ile varsayılan Blockbench tuş atamaları",
	"action.load_keymap.mouse.desc": "Görünüm alanı gezinmesi orta fare düğmesine bağlı olan varsayılan Blockbench tuş atamaları",
	"action.load_keymap.blender.desc": "Blender kontrollerine aşina olan kullanıcılar için tuş haritası",
	"action.load_keymap.cinema4d.desc": "Cinema 4D kontrollerine aşina olan kullanıcılar için tuş haritası",
	"action.load_keymap.maya.desc": "Autodesk Maya kontrollerine aşina olan kullanıcılar için tuş haritası",
	"action.import_keymap": "Tuş Haritası İçe Aktar",
	"action.import_keymap.desc": "Bir .bbkeymap dosyasından tuş atamalarını içe aktarın",
	"action.export_keymap": "Tuş Haritası Dışa Aktar",
	"action.export_keymap.desc": "Mevcut tuş atamalarını bir .bbkeymap dosyası olarak dışa aktarın",
	"action.edit_history": "Düzenleme Geçmişi...",
	"action.edit_history.desc": "Düzenleme geçmişini görüntüleyin ve adımları geri alın veya yineleyin",
	"action.group_elements": "Öğeleri Gruplandır",
	"action.group_elements.desc": "Seçili öğeleri yeni bir gruba sarın",
	"action.unfold_groups": "Grupları Aç",
	"action.unfold_groups.desc": "Anahattaki tüm grupları açın",
	"action.edit_bedrock_binding": "Bağlantıyı Düzenle...",
	"action.edit_bedrock_binding.desc": "Geometrinin hangi kemiğe bağlı olduğunu değiştirin",
	"action.pick_screen_color": "Ekran Rengi Seç",
	"action.pick_screen_color.desc": "Ekranınızın herhangi bir yerinden bir renk seçin",
	"action.view_mode": "Görünüm Modu",
	"action.view_mode.desc": "Model görünüm modunu değiştirin",
	"action.view_mode.textured": "Dokulu",
	"action.view_mode.solid": "Katı",
	"action.view_mode.wireframe": "Tel Kafes",
	"action.toggle_sidebars": "Kenar Çubuklarını Aç/Kapat",
	"action.toggle_sidebars.desc": "Kenar çubuklarını etkinleştirin veya devre dışı bırakın",
	"action.set_animation_end": "Animasyon Sonunu Ayarla",
	"action.set_animation_end.desc": "Seçili animasyonun sonunu mevcut zaman çizelgesi zamanına ayarlayın",
	"action.flip_animation": "Animasyonu Çevir",
	"action.flip_animation.desc": "Seçili anahtar kareleri modelin diğer tarafına kopyalayarak bir animasyonun parçasını çevirir",
	"action.graph_editor_zero_line": "Sıfır Çizgisini Dahil Et",
	"action.graph_editor_zero_line.desc": "Grafik düzenleyicinin görünümde her zaman sıfır çizgisini içerip içermediği",
	"menu.texture.render_mode": "Render Modu",
	"menu.texture.render_mode.emissive": "Yayıcı",
	"menu.texture.render_mode.layered": "Katmanlı",
	"menu.preview.angle.edit": "Açıyı Düzenle...",
	"menu.animation.start_delay": "Başlangıç Gecikmesi",
	"menu.animation.loop_delay": "Döngü Gecikmesi",
	"menu.animation.flip_keyframes": "Anahtar Kareleri Çevir",
	"menu.mobile_keyboard.disable_all": "Tümünü Devre Dışı Bırak",
	"panel.keyframe.toggle_uniform_scale": "Orantılı Ölçeği Aç/Kapat",
	"camera_angle.common_isometric_right": "İzometrik Sağ (2:1)",
	"camera_angle.common_isometric_left": "İzometrik Sol (2:1)",
	"camera_angle.true_isometric_right": "Gerçek İzometrik Sağ (30°)",
	"camera_angle.true_isometric_left": "Gerçek İzometrik Sol (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Ön Sürümlere Güncelle",
	"settings.update_to_prereleases.desc": "Yeni özellikleri test etmek için Blockbench beta sürümlerine otomatik olarak güncelleyin. Ön sürüm versiyonları kararsız olabilir, iş veya diğer önemli projeler için Blockbench'e güveniyorsanız bu seçeneği etkinleştirmeyin.",
	"data.separator.spacer": "Boşluk",
	"data.separator.linebreak": "Satır Sonu",
	"data.setting": "Ayar",
	"generic.select_all": "Tümünü Seç",
	"generic.select_none": "Seçimi Kaldır",
	"projects.new_tab": "Yeni Sekme",
	"projects.close_tab": "Sekmeyi Kapat",
	"message.invalid_format.title": "Geçersiz Biçim",
	"message.invalid_format.message": "Bu model, Blockbench kurulumunuzda bulunmayan '%0' biçiminde yapılmıştır. Doğru şekilde açmak için büyük olasılıkla belirli bir eklentiye ihtiyacınız var.",
	"message.invalid_link": "Geçersiz veya Süresi Dolmuş Model Bağlantısı",
	"message.default_textures.current": "Mevcut yol",
	"message.update_after_restart": "Güncelleme bir sonraki yeniden başlatmadan sonra yüklenecektir",
	"message.copy_paste_tool_viewport": "Bu araç yalnızca 2B düzenleyicide kullanılabilir",
	"dialog.project.shadow_size": "Gölge Boyutu",
	"dialog.find_replace.target": "Hedef",
	"dialog.find_replace.target.element_names": "Öğe Adları",
	"dialog.find_replace.target.group_names": "Grup Adları",
	"dialog.find_replace.target.animation_names": "Animasyon Adları",
	"dialog.find_replace.target.keyframe_values": "Anahtar Kare Değerleri",
	"dialog.find_replace.find": "Bul",
	"dialog.find_replace.replace": "Değiştir",
	"dialog.find_replace.regex": "Normal İfade",
	"dialog.add_primitive.shape": "Şekil",
	"dialog.add_primitive.shape.circle": "Daire",
	"dialog.add_primitive.shape.tube": "Tüp",
	"dialog.add_primitive.shape.cone": "Koni",
	"dialog.add_primitive.shape.cylinder": "Silindir",
	"dialog.add_primitive.shape.sphere": "Küre",
	"dialog.add_primitive.shape.torus": "Simit",
	"dialog.add_primitive.shape.cube": "Küboid",
	"dialog.add_primitive.shape.pyramid": "Piramit",
	"dialog.add_primitive.diameter": "Çap",
	"dialog.add_primitive.height": "Yükseklik",
	"dialog.add_primitive.sides": "Yanlar",
	"dialog.add_primitive.minor_diameter": "Kalınlık",
	"dialog.add_primitive.minor_sides": "Küçük Yanlar",
	"dialog.create_texture.combine_polys": "Adaları Birleştir",
	"dialog.create_texture.combine_polys.desc": "Yüzleri bağlı UV adalarına birleştirin",
	"dialog.model_stats.meshes": "Ağlar",
	"dialog.export_private_settings.omit": "Dışarıda Bırak",
	"layout.select": "Seç",
	"layout.options": "Seçenekler",
	"layout.color": "Renk Şeması",
	"layout.documentation": "Belgeler",
	"layout.color.bright_ui_text": "Parlak Arayüz Metni",
	"layout.color.bright_ui_text.desc": "Parlak arka planlardaki metin",
	"layout.name": "İsim",
	"layout.author": "Yazar",
	"settings.dialog.desc": "\"%0\" diyaloğunu göster",
	"settings.export_empty_groups": "Boş Grupları Dışa Aktar",
	"settings.export_empty_groups.desc": "İçeriği olmayan grupları dışa aktarılan dosyalara dahil et",
	"category.separators": "Ayırıcılar",
	"keybind.preview_area_select": "Alan Seç",
	"action.color_erase_mode": "Silme Modu",
	"action.color_erase_mode.desc": "Silme modu etkinken, Doldur ve Dikdörtgen gibi araçlar renk eklemek yerine renk çıkarır",
	"action.open_from_link": "Bağlantıdan Model Aç...",
	"action.open_from_link.desc": "Bir blckbn.ch URL'sinden bir model açın",
	"action.import_obj": "OBJ Modeli İçe Aktar",
	"action.import_obj.desc": "Bir OBJ modelinden nesneleri ağ olarak içe aktarır",
	"action.add_plugin": "Eklenti Yükle",
	"action.add_plugin.desc": "Eylem Kontrolü aracılığıyla bir eklenti yükleyin",
	"action.remove_plugin": "Eklentiyi Kaldır",
	"action.remove_plugin.desc": "Eylem Kontrolü aracılığıyla bir eklentiyi kaldırın",
	"action.add_mesh": "Ağ Ekle",
	"action.add_mesh.desc": "Yeni bir ağ ekler",
	"action.add_texture_mesh": "Dokulu Ağ Ekle",
	"action.add_texture_mesh.desc": "Yeni bir Dokulu Ağ ekler",
	"action.find_replace": "Bul/Değiştir...",
	"action.find_replace.desc": "İsimlerin parçalarını bulun ve değiştirin",
	"action.hide_everything_except_selection": "Seçim Dışındaki Her Şeyi Gizle",
	"action.hide_everything_except_selection.desc": "Seçili olanlar dışındaki tüm öğelerde görünürlüğü aç/kapat",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Seçim Modu",
	"action.selection_mode.desc": "Görünüm alanında öğelerin nasıl seçilebileceğini değiştirin",
	"action.selection_mode.object": "Nesne",
	"action.selection_mode.face": "Yüz",
	"action.selection_mode.vertex": "Tepe Noktası",
	"action.create_face": "Yüz veya Kenar Oluştur",
	"action.create_face.desc": "Seçili tepe noktaları arasında yeni bir yüz veya kenar oluşturur",
	"action.convert_to_mesh": "Ağa Dönüştür",
	"action.convert_to_mesh.desc": "Seçili öğeleri ağlara dönüştürün",
	"action.invert_face": "Yüzü Ters Çevir",
	"action.invert_face.desc": "Seçili yüzleri ters yöne bakacak şekilde ters çevirin",
	"action.extrude_mesh_selection": "Seçimi Dışa Çıkar",
	"action.extrude_mesh_selection.desc": "Ağın seçili kısımlarını dışa çıkarın",
	"action.loop_cut": "Döngü Kesimi",
	"action.loop_cut.desc": "Ağı seçili kenar boyunca bir döngüde bölün",
	"action.merge_meshes": "Ağları Birleştir",
	"action.merge_meshes.desc": "Birden fazla ağı birine birleştirin",
	"action.keyframe_uniform": "Orantılı Ölçeklendirme",
	"action.keyframe_uniform.desc": "Seçili anahtar karelerde orantılı ölçeklendirmeyi etkinleştirin",
	"menu.locator.ignore_inherited_scale": "Devralınan Ölçeği Yoksay",
	"menu.texture.elements": "Öğelere Uygula",
	"uv_editor.transparent_face": "Şeffaf Yüz",
	"display.pose_angle": "Poz Açısı (Sadece Önizleme İçin)",
	"data.mesh": "Ağ (Mesh)",
	"dialog.create_texture.type": "Tip",
	"dialog.create_texture.type.blank": "Boş",
	"dialog.create_texture.type.template": "Doku Şablonu",
	"dialog.create_texture.type.color_map": "Düz Renk Şablonu",
	"dialog.sketchfab_uploader.suggested_tags": "Önerilen Etiketler",
	"dialog.sketchfab_uploader.category": "Kategori",
	"dialog.sketchfab_uploader.category2": "Kategori 2",
	"layout.restore_backup": "Özelleştirilmiş temanız \"%0\" üzerine yazıldı. Geri yüklemek için buraya tıklayın.",
	"layout.borders": "Kenarlıklar",
	"action.fill_mode.element": "Öğe",
	"action.inset_mesh_selection": "Seçimi İçeri Çek",
	"action.inset_mesh_selection.desc": "Ağın seçili kısımlarını içeri çekin",
	"action.dissolve_edges": "Kenarları Çöz",
	"action.dissolve_edges.desc": "Bir ağda seçili kenarları çözün ve böldükleri yüzleri birleştirin",
	"action.split_mesh": "Ağı Böl",
	"action.split_mesh.desc": "Ağın seçili yüzlerini yeni bir ağa bölün",
	"action.merge_vertices": "Tepe Noktalarını Birleştir",
	"action.merge_vertices.desc": "Seçili tepe noktalarını ilk seçilen tepe noktasının konumuna birleştirin",
	"action.view_mode.normal": "Yüz Yönelimi",
	"action.snap_uv_to_pixels": "UV'yi Piksellere Yasla",
	"action.snap_uv_to_pixels.desc": "Seçili UV tepe noktalarını piksel ızgarasına yaslar",
	"menu.file.import.import_open_project": "Açık Projeyi İçe Aktar",
	"menu.help.unlock_projects": "Tüm Projelerin Kilidini Aç",
	"status_bar.selection.faces": "%0 Yüz",
	"status_bar.selection.vertices": "%0 Tepe Noktası",
	"message.merged_vertices": "%1 konumda %0 tepe noktası bulundu ve birleştirildi",
	"settings.vertex_merge_distance": "Tepe Noktası Birleştirme Mesafesi",
	"settings.vertex_merge_distance.desc": "Mesafe ile birleştirme kullanılarak tepe noktalarının birleştirildiği mesafe",
	"settings.show_only_selected_uv": "Yalnızca Seçili UV'yi Göster",
	"settings.show_only_selected_uv.desc": "Varsayılan olarak UV düzenleyicide yalnızca seçili UV yüzlerini görüntüle",
	"action.merge_vertices.merge_all": "Tümünü Birleştir",
	"action.merge_vertices.merge_all_in_center": "Tümünü Merkezde Birleştir",
	"action.merge_vertices.merge_by_distance": "Mesafeye Göre Birleştir",
	"action.merge_vertices.merge_by_distance_in_center": "Mesafeye Göre Merkezde Birleştir",
	"action.uv_rotate_left": "UV'yi Sola Döndür",
	"action.uv_rotate_left.desc": "Seçili UV yüzlerini saat yönünün tersine döndürün",
	"action.uv_rotate_right": "UV'yi Sağa Döndür",
	"action.uv_rotate_right.desc": "Seçili UV yüzlerini saat yönünde döndürün",
	"menu.uv.display_uv": "UV'yi Görüntüle",
	"menu.uv.display_uv.selected_faces": "Seçili Yüzler",
	"menu.uv.display_uv.selected_elements": "Tüm Yüzler",
	"menu.uv.display_uv.all_elements": "Tüm Öğelerdeki Tüm Yüzler",
	"menu.paste.face": "UV Yüzü",
	"menu.paste.mesh_selection": "Ağ Seçimi",
	"menu.paste.outliner": "Öğeler",
	"uv_editor.show_all_faces": "Tüm Yüzleri Göster",
	"uv_editor.show_selected_faces": "Seçili Yüzleri Göster",
	"status_bar.selection.edges": "%0 Kenar",
	"action.selection_mode.edge": "Kenar",
	"message.cannot_re_import.title": "Model yeniden içe aktarılamıyor",
	"message.cannot_re_import.message": "Dışa aktarılan model biçimi tekrar Blockbench'e aktarılamaz. Lütfen modelinizi bir proje dosyası olarak kaydettiğinizden emin olun.",
	"generic.default": "Varsayılan",
	"units.pixels_per_meter": "Metre başına %0 Piksel",
	"mode.pose": "Poz",
	"modifier_actions.resize_both_sides": "Her iki yönde yeniden boyutlandır",
	"modifier_actions.resize_one_side": "Tek yönde yeniden boyutlandır",
	"modifier_actions.draw_line": "Çizgi çiz",
	"modifier_actions.drag_without_snapping": "Yaslamadan sürükle",
	"modifier_actions.stretch_keyframes": "Anahtar kareleri uzat",
	"modifier_actions.resize_background": "Arka planı yeniden boyutlandır",
	"modifier_actions.select_multiple": "Çoklu seç",
	"modifier_actions.select_range": "Aralık seç",
	"modifier_actions.drag_to_duplicate": "Çoğaltmak için sürükle",
	"modifier_actions.uniform_scaling": "Orantılı Ölçeklendirme",
	"modifier_actions.snap_direction": "Yönü Yasla",
	"message.no_valid_elements": "Geçerli öğe seçilmedi...",
	"dialog.add_primitive.shape.plane": "Düzlem",
	"dialog.save_angle.rotation_mode": "Döndürme Modu",
	"dialog.save_angle.rotation": "Döndürme",
	"dialog.save_angle.fov": "Görüş Alanı (FOV)",
	"settings.hide_tab_bar": "Sekme Çubuğunu Otomatik Gizle",
	"settings.hide_tab_bar.desc": "Yalnızca bir sekme açıkken sekme çubuğunu gizle",
	"settings.status_bar_modifier_keys": "Durum Çubuğunda Değiştirici Tuşları Öner",
	"settings.status_bar_modifier_keys.desc": "Durum çubuğunda bağlama duyarlı önerilen değiştirici tuşları görüntüle",
	"settings.ground_plane": "Zemin Düzlemi",
	"settings.ground_plane.desc": "Modelin altında bir zemin düzlemi göster",
	"settings.preview_paste_behavior": "Varsayılan Görünüm Alanı Yapıştırma Davranışı",
	"settings.preview_paste_behavior.desc": "Düzenleme modunda görünüm alanına bir şey yapıştırıldığında ve birden fazla seçenek mevcut olduğunda davranışı seçin",
	"settings.preview_paste_behavior.always_ask": "Her Zaman Sor",
	"action.new_window": "Yeni Pencere",
	"action.new_window.desc": "Yeni bir Blockbench penceresi açar",
	"action.export_collada": "Collada Modelini (dae) Dışa Aktar",
	"action.export_collada.desc": "Modeli ve animasyonları diğer 3B uygulamalarda kullanmak üzere dae dosyası olarak dışa aktarın",
	"action.paint_mode_uv_overlay": "UV Kaplaması",
	"action.paint_mode_uv_overlay.desc": "UV haritasını boya modunda bir kaplama olarak görüntüleyin",
	"action.bake_animation_into_model": "Animasyonu Modele Pişir",
	"action.bake_animation_into_model.desc": "Şu anda görüntülenen animasyon karesini modele pişirin. Yalnızca döndürme ve konum uygulanır, ölçek göz ardı edilir.",
	"action.keyframe_interpolation.step": "Adım",
	"action.set_ik_target": "IK Hedefini Ayarla",
	"action.set_ik_target.desc": "Bu boş nesne tarafından Ters Kinematik aracılığıyla taşınması gereken hedef kemiği seçin",
	"menu.action_control.type.tab": "Sekme",
	"menu.action_control.type.angle": "Kamera Açısı",
	"menu.action_control.recent_in_streamer_mode": "Emin misiniz? Yayıncı Modu etkin",
	"menu.action_control.recent_in_streamer_mode.desc": "Son modelleri görüntülemek istediğinizden emin misiniz?",
	"menu.tools": "Araçlar",
	"menu.file.recent.more": "Daha Fazla Görüntüle...",
	"menu.null_object.lock_ik_target_rotation": "IK Hedef Döndürmesini Kilitle",
	"menu.animation_file.import_remaining": "Dosyadan Kalanı İçe Aktar",
	"edit.loop_cut.offset": "Ofset",
	"edit.extrude_mesh_selection.extend": "Genişlet",
	"cube.color.pink": "Pembe",
	"cube.color.silver": "Gümüş",
	"dialog.plugins.offline": "İnternet bağlantısı yok",
	"dialog.create_texture.pixel_density": "Piksel Yoğunluğu",
	"dialog.create_texture.pixel_density.desc": "Dokunun piksel yoğunluğu, metre başına piksel cinsinden. Doku haritasının boyutu, öğelerin miktarına ve boyutuna bağlı olarak farklılık gösterebilir.",
	"panel.skin_pose": "Poz",
	"panel.skin_pose.none": "Hiçbiri",
	"panel.skin_pose.natural": "Doğal",
	"panel.skin_pose.walking": "Yürüme",
	"panel.skin_pose.crouching": "Çömelme",
	"panel.skin_pose.sitting": "Oturma",
	"panel.skin_pose.jumping": "Zıplama",
	"panel.skin_pose.aiming": "Nişan Alma",
	"edit.loop_cut.direction": "Yön",
	"data.texture_mesh": "Dokulu Ağ",
	"generic.left": "Sol",
	"generic.right": "Sağ",
	"mode.start.quick_setup": "Hızlı Kurulum",
	"mode.start.keymap": "Tuş Haritası",
	"mode.start.quick_setup.more_themes": "Daha Fazla...",
	"dialog.resize_texture.animation_frames": "Animasyon Kareleri",
	"dialog.export_emission_map.title": "Emisyon Haritasını Dışa Aktar",
	"dialog.export_emission_map.format": "Format",
	"dialog.export_emission_map.format.luminance": "Parlaklık",
	"dialog.export_emission_map.format.luminance_inverted": "Ters Çevrilmiş Parlaklık",
	"dialog.export_emission_map.format.colors": "Renkler",
	"dialog.export_emission_map.threshold": "Şeffaflık Eşiği",
	"dialog.export_emission_map.round_up": "%0 x %1'e Yuvarla",
	"dialog.export_emission_map.flip_y": "Y Ekseninde Çevir",
	"dialog.select.type": "Öğe Türü",
	"dialog.create_texture.max_edge_angle": "Kenar Açısı Eşiği",
	"dialog.create_texture.max_edge_angle.desc": "İki yüzün hala birleştirileceği maksimum açı",
	"dialog.create_texture.max_island_angle": "Ada Açısı Eşiği",
	"dialog.create_texture.max_island_angle.desc": "Aynı UV adasına birleştirilebilecek maksimum açı",
	"settings.mobile_panel_side": "Mobil Panel Tarafı",
	"settings.mobile_panel_side.desc": "Blockbench'i yatay yönde kullanırken panellerin ekranın hangi tarafında görüntüleneceğini seçin",
	"settings.obj_face_export_mode": "OBJ Yüz Dışa Aktarma Modu",
	"settings.obj_face_export_mode.desc": "OBJ dışa aktarıcısının tüm yüzleri üçgenlere mi yoksa dörtgenlere mi dönüştüreceğini seçin",
	"settings.obj_face_export_mode.both": "Varsayılan",
	"settings.obj_face_export_mode.tris": "Üçgenlere Dönüştür",
	"settings.obj_face_export_mode.quads": "Dörtgenlere Dönüştür",
	"action.seam_tool": "Dikiş Aracı",
	"action.seam_tool.desc": "Ağ kenarlarında UV dikişlerini tanımlama aracı",
	"action.resolve_group": "Grubu Çöz",
	"action.resolve_group.desc": "Çocuklarını aynı yerde tutarak grubu çözün",
	"action.move_to_group": "Gruba Taşı",
	"action.move_to_group.desc": "Seçili öğeleri farklı bir anahat grubuna taşıyın",
	"action.select_seam": "UV Dikişini Seç",
	"action.select_seam.desc": "Seçili kenarlar için UV dikiş modunu seçin",
	"action.select_seam.auto": "Otomatik",
	"action.select_seam.join": "Birleştir",
	"action.select_seam.divide": "Böl",
	"action.adjust_brightness_contrast": "Parlaklığı ve Kontrastı Ayarla...",
	"action.adjust_brightness_contrast.desc": "Seçili dokunun parlaklığını ve kontrastını ayarlayın",
	"action.adjust_saturation_hue": "Doygunluğu ve Tonu Ayarla...",
	"action.adjust_saturation_hue.desc": "Seçili dokunun doygunluğunu ve tonunu ayarlayın",
	"action.invert_colors": "Renkleri Ters Çevir",
	"action.invert_colors.desc": "Seçili dokunun tüm renklerini ters çevirin",
	"action.adjust_curves": "Eğrileri Ayarla...",
	"action.adjust_curves.desc": "Seçili dokunun parlaklık eğrilerini ayarlayın",
	"action.flip_texture_x": "Yatay Olarak Çevir",
	"action.flip_texture_y": "Dikey Olarak Çevir",
	"action.resize_texture": "Dokuyu Yeniden Boyutlandır...",
	"action.view_mode.uv": "UV Önizleme",
	"action.append_to_template": "Öğeleri Şablona Ekle...",
	"action.append_to_template.desc": "Şu anda seçili olan öğeleri doku şablonuna ekleyin",
	"action.move_texture_with_uv": "Dokuyu UV ile Taşı",
	"action.move_texture_with_uv.desc": "UV yüzlerini sürüklerken yüzün dokusunu da taşıyın",
	"action.timeline_setups": "Zaman Çizelgesi Kurulumları",
	"action.save_timeline_setup": "Zaman Çizelgesi Kurulumunu Kaydet...",
	"action.save_timeline_setup.desc": "Şu anda seçili olan animatörler ve kanallar için bir ön ayar kaydedin",
	"menu.texture": "Doku",
	"menu.texture.render_mode.default": "Varsayılan",
	"menu.texture.merge_onto_texture": "Yukarıdaki Dokuya Birleştir",
	"menu.animation.unload": "Boşalt",
	"panel.timeline": "Zaman Çizelgesi",
	"action.pan_tool": "Kaydırma Aracı",
	"action.pan_tool.desc": "Görünüm alanı ve doku düzenleyicide gezinme aracı",
	"mode.start.recent.favorite": "Favori Olarak İşaretle",
	"mode.start.info": "Bilgi",
	"mode.start.target": "Hedef",
	"mode.start.start": "Başlat",
	"mode.start.create_new": "Yeni Model Oluştur",
	"mode.start.format.informations": "Bilmen iyi olur:",
	"mode.start.format.resources": "Kaynaklar:",
	"format.free.info.meshes": "Bu formatta küpler ve özel şekilli ağlar kullanarak düşük poligonlu modeller oluşturabilirsiniz.",
	"format.free.info.limitation": "Bu modeller, Minecraft gibi özel formatlara ihtiyaç duyan oyunlara yüklenemez.",
	"format.skin.info.skin": "Bu format Minecraft kaplamaları ve varlık dokuları oluşturmak için tasarlanmıştır.",
	"format.skin.info.model": "Model değiştirilemez. Değişiklik yapmak için **Dosya > Projeyi Dönüştür** seçeneğini kullanarak farklı bir formata dönüştürmelisiniz.",
	"format.java_block.info.rotation": "Dönmeler her öğe için yalnızca bir eksenle sınırlıdır",
	"format.java_block.info.size": "Modelin boyutu 3x3x3 blokla sınırlıdır. Görüntüleme ayarları, öğe modellerini daha büyük gösterebilir",
	"format.java_block.info.animation": "Bu format, vanilla Minecraft'ta animasyon desteklemez. Mod yapıyorsanız GeckoLib kullanabilirsiniz. Değilse, animasyonun tek yolu modeli komutlarla veya animasyonlu dokularla değiştirmektir.",
	"format.bedrock.info.textures": "Her model yalnızca bir dokuya sahip olabilir",
	"format.bedrock_block": "Bedrock Blok",
	"format.bedrock_block.desc": "Minecraft Bedrock Sürümü için blok modeli",
	"format.modded_entity.info.integer_size": "Bireysel küplerin boyutu yalnızca tam sayılar olabilir.",
	"format.modded_entity.info.format": "Modeller, diğer tüm Blockbench dışa aktarma formatlarının aksine özel veri yapıları yerine Java kodu olarak yazılır.",
	"format.optifine_entity.info.optifine_required": "OptiFine yüklü olmayan kullanıcılar modeli göremez.",
	"format.optifine_entity.info.pivots": "Kemik merkezleri sabittir, bu yüzden bunlara dokunmamak iyi bir fikirdir.",
	"format_category.low_poly": "Düşük Poligon",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Diğer",
	"format_category.loaders": "Yükleyiciler",
	"message.recover_backup.recover": "Kurtar",
	"message.invalid_characters.title": "Geçersiz Yol",
	"message.invalid_characters.message": "İçe aktarılan dosyanın yolu geçersiz karakterler, büyük harfler veya boşluklar içeriyor. Desteklenen karakterler şunlardır: %0",
	"dialog.share_model.thumbnail": "Küçük Resim",
	"dialog.skin.high_res_texture": "Lütfen seçilen çözünürlüğe sahip kaplamaların normal Minecraft kaplamaları olarak çalışmayacağını unutmayın. Daha düşük bir çözünürlük seçin.",
	"settings.allow_display_slot_mirror": "Görüntüleme Yuvası Aynalamasına İzin Ver",
	"settings.allow_display_slot_mirror.desc": "Java öğe modelleri için Görüntüleme yuvalarının aynalanmasına izin verin. UYARI: Bu yalnızca Minecraft 1.14 veya daha önceki sürümlerde veya özel durumlarda çalışır.",
	"action.switch_tabs": "Sekmeleri Değiştir",
	"action.switch_tabs.desc": "Açılan sekmeler arasında geçiş yapın. Ters yönde geçiş yapmak için shift tuşunu basılı tutun.",
	"action.unselect_all": "Tüm Seçimi Kaldır",
	"action.save_palette": "Paleti Kaydet...",
	"action.save_palette.desc": "Mevcut renk paletini daha sonra kullanmak üzere Blockbench içinde kaydedin",
	"action.keyframe_column_create": "Anahtar Kare Sütunu Oluştur",
	"action.keyframe_column_create.desc": "Zaman çizelgesindeki tüm kanalları, zaten anahtar kareleri varsa, mevcut zaman kodunda anahtarlayın",
	"action.keyframe_column_select": "Anahtar Kare Sütununu Seç",
	"action.keyframe_column_select.desc": "Oynatma kafasının altındaki bir sütun boyunca zaman çizelgesindeki tüm anahtar kareleri seçin",
	"menu.uv": "UV",
	"menu.keyframe": "Anahtar Kare",
	"menu.palette.load.update": "Paleti Güncelle",
	"menu.palette.load.update.desc": "Bu paleti mevcut Blockbench paletinin renkleriyle günceller",
	"menu.timeline_marker.set_time": "Zamanı Ayarla...",
	"uv_editor.scale_uv": "UV'yi Ölçeklendir",
	"action.preview_scene": "Önizleme Sahnesi",
	"action.preview_scene.desc": "Model önizleme sahnesini değiştirin",
	"preview_scene.minecraft_overworld": "Üst Dünya",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Y Ekseni Çevir",
	"preview_scene.studio": "Stüdyo",
	"format.image": "Görsel",
	"modifier_actions.set_copy_source": "Kopyalama Kaynağını Ayarla",
	"message.load_images.title": "Görselleri Yükle",
	"message.load_images.edit_image": "Görseli Düzenle",
	"dialog.add_primitive.align_edges": "Kenarları Hizala",
	"dialog.flip_animation.show_in_timeline": "Zaman çizelgesinde değiştirilmiş kemikleri göster",
	"settings.default_cube_size": "Küp Boyutu",
	"settings.default_cube_size.desc": "Yeni bir küp oluştururken varsayılan küp boyutunu ayarlayın",
	"settings.uniform_keyframe": "Orantılı Ölçek Anahtar Kareleri",
	"settings.uniform_keyframe.desc": "Ölçek anahtar karelerini varsayılan olarak orantılı ölçeklendirmeye ayarlayın",
	"settings.nearest_rectangle_select": "Dikdörtgen Seçimi: En Yakın Kenar",
	"settings.nearest_rectangle_select.desc": "Dikdörtgen seçimlerini GIMP'teki gibi tam pikseller yerine en yakın piksel kenarına yaslayın.",
	"settings.pick_color_opacity": "Renk Opaklığını Seç",
	"settings.pick_color_opacity.desc": "Renk Seçici ile renk opaklığını seçin ve fırça opaklığı olarak ayarlayın",
	"settings.paint_with_stylus_only": "Yalnızca Stylus ile Boya",
	"settings.paint_with_stylus_only.desc": "Yalnızca boyama için stylus kullanın, fare veya dokunmatik girişi navigasyon için ayırın.",
	"action.copy_brush_mode": "Kopya Fırça Modu",
	"action.copy_brush_mode.copy": "Kopyala",
	"action.copy_brush_mode.pattern": "Desen",
	"action.copy_brush_mode.sample": "Örnek",
	"action.brush_shape": "Fırça Şekli",
	"action.brush_shape.square": "Kare",
	"action.brush_shape.circle": "Daire",
	"action.blend_mode": "Karışım Modu",
	"action.blend_mode.default": "Varsayılan",
	"action.blend_mode.set_opacity": "Opaklığı Ayarla",
	"action.blend_mode.color": "Renk",
	"action.blend_mode.behind": "Arkada",
	"action.blend_mode.multiply": "Çarp",
	"action.blend_mode.divide": "Böl",
	"action.blend_mode.add": "Ekle",
	"action.blend_mode.subtract": "Çıkar",
	"action.blend_mode.screen": "Ekran",
	"action.blend_mode.overlay": "Kaplama",
	"action.blend_mode.hard_light": "Sert Işık",
	"action.blend_mode.difference": "Fark",
	"action.copy_brush": "Kopya Fırça",
	"action.copy_brush.desc": "Dokunuzun parçalarını klonlamak veya desenler çizmek için fırça. Kopyalama kaynağı seçmek için Ctrl tuşunu basılı tutun ve tıklayın.",
	"action.validator_window": "Model Sorunlarını Görüntüle...",
	"action.validator_window.desc": "Mevcut modelle ilgili sorunları listeleyen doğrulayıcıyı açar.",
	"action.cancel_gif": "GIF'i İptal Et",
	"menu.text_edit.copy_vector": "Vektörü Kopyala",
	"menu.brush_presets.dialog": "Fırça Ön Ayarları...",
	"menu.brush_presets.pixel_brush": "Piksel Fırça",
	"menu.brush_presets.smooth_brush": "Yumuşak Fırça",
	"menu.texture.edit_in_blockbench": "Blockbench'te Düzenle",
	"menu.mirror_painting.axis": "Eksen",
	"menu.mirror_painting.axis.desc": "Boya darbelerinin hangi eksende yansıtılacağını seçin",
	"menu.mirror_painting.global": "Global Simetri",
	"menu.mirror_painting.global.desc": "Model üzerinde global alanda ayna boyamayı etkinleştirin",
	"menu.mirror_painting.local": "Yerel Simetri",
	"menu.mirror_painting.local.desc": "Her öğe için yerel alanda ayna boyamayı etkinleştirin",
	"menu.mirror_painting.texture_frames": "Flipbook Karelerinde Tekrarla",
	"menu.mirror_painting.texture_frames.desc": "Boya darbelerini animasyonlu dokuların her karesine yansıtın",
	"format.bedrock_block.info.size_limit": "Bir bloğun toplam boyutu tüm yönlerde 30 piksel ile sınırlıdır. Bu sınır, blok merkezinden 7 piksel sapabilir.",
	"format.bedrock_block.info.textures": "Blockbench içinde farklı küplere birden fazla doku uygulanabilir, ancak oyunda düzgün çalışması için davranış paketi içinde ek ayarlamalar gerekir.",
	"format.image.desc": "2B görsel düzenleyicisinde görselleri düzenle",
	"generic.delete_all": "Tümünü Sil",
	"message.child_model_only.open": "Üst Öğeyi Aç",
	"dialog.project.credit": "Katkıda Bulunan",
	"dialog.convert_project.create_copy": "Kopya Oluştur",
	"dialog.texture.frame_time": "Kare Süresi",
	"dialog.texture.frame_time.desc": "Her karenin ne kadar süreyle görüneceğini tik olarak ayarlayın. Her tik bir saniyenin 1/20'sidir.",
	"dialog.texture.frame_interpolate": "İnterpolasyon",
	"dialog.texture.frame_interpolate.desc": "Bir sonraki kareye çapraz geçiş yaparak animasyon kareleri arasında interpolasyon yapın",
	"dialog.texture.frame_order_type": "Döngü Modu",
	"dialog.texture.frame_order_type.loop": "Döngü",
	"dialog.texture.frame_order_type.backwards": "Geriye Döngü",
	"dialog.texture.frame_order_type.back_and_forth": "İleri-Geri",
	"dialog.texture.frame_order_type.custom": "Özel Sıra",
	"dialog.texture.frame_order": "Kare Sırası",
	"dialog.texture.frame_order.desc": "Kare dizinlerini yeni bir sırada listeleyerek özel bir kare sırası ayarlayın. Kare dizinleri ilk kare ile 0'dan başlar.",
	"dialog.select.mode": "Mod",
	"dialog.select.mode.new": "Yeni Seçim",
	"dialog.select.mode.add": "Seçiliye Ekle",
	"dialog.select.mode.remove": "Seçiliden Kaldır",
	"dialog.select.mode.in_selection": "Yalnızca Seçiliden Seç",
	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Koşullar",
	"dialog.predicate_overrides.variants": "Varyantlar",
	"dialog.predicate_overrides.start_value": "Başlangıç",
	"dialog.predicate_overrides.add_override": "Geçersiz Kılma Ekle",
	"dialog.predicate_overrides.add_predicate": "Koşul Ekle",
	"dialog.predicate_overrides.generate_overrides": "Geçersiz Kılmaları Oluştur",
	"dialog.predicate_overrides.confirm_delete": "Tüm geçersiz kılmaları silmek istediğinizden emin misiniz?",
	"dialog.predicate_overrides.predicate.angle": "Pusula Açısı",
	"dialog.predicate_overrides.predicate.blocking": "Engelliyor mu",
	"dialog.predicate_overrides.predicate.broken": "Kırık mı",
	"dialog.predicate_overrides.predicate.cast": "Atıldı mı",
	"dialog.predicate_overrides.predicate.cooldown": "Bekleme Süresi",
	"dialog.predicate_overrides.predicate.damage": "Hasar",
	"dialog.predicate_overrides.predicate.damaged": "Hasarlı mı",
	"dialog.predicate_overrides.predicate.lefthanded": "Solak mı",
	"dialog.predicate_overrides.predicate.pull": "Çekme Miktarı",
	"dialog.predicate_overrides.predicate.pulling": "Çekiyor mu",
	"dialog.predicate_overrides.predicate.charged": "Şarjlı mı",
	"dialog.predicate_overrides.predicate.firework": "Havai Fişek Var mı",
	"dialog.predicate_overrides.predicate.throwing": "Atmaya Hazır",
	"dialog.predicate_overrides.predicate.time": "Günün Saati",
	"dialog.predicate_overrides.predicate.custom_model_data": "Özel Model Verisi",
	"dialog.predicate_overrides.predicate.level": "Işık Seviyesi",
	"dialog.predicate_overrides.predicate.filled": "Paket Doluluk Seviyesi",
	"dialog.predicate_overrides.predicate.tooting": "Korna Çalıyor",
	"settings.model_export_scale": "Model Dışa Aktarma Ölçeği",
	"settings.model_export_scale.desc": "Dışa aktarılan glTF, DAE ve FBX modellerinin ölçeğinin azaltıldığı faktör. Varsayılan 16'dır, bu da dışa aktarmada 16 Blockbench birimini 1 metreye dönüştürür.",
	"action.export_fbx": "FBX Modelini Dışa Aktar",
	"action.export_fbx.desc": "Modeli ve animasyonları diğer 3B uygulamalarda ve oyun motorlarında kullanmak üzere fbx dosyası olarak dışa aktarın",
	"action.center_lateral": "Yanal Ortala",
	"action.center_lateral.desc": "Seçili öğeleri X ve Z ekseninde ortalayın",
	"action.adjust_opacity": "Opaklığı Ayarla...",
	"action.adjust_opacity.desc": "Seçili dokunun opaklığını ayarlayın",
	"action.rotate_texture_cw": "Saat Yönünde Döndür",
	"action.rotate_texture_ccw": "Saat Yönünün Tersine Döndür",
	"action.predicate_overrides": "Koşul Geçersiz Kılmalarını Düzenle...",
	"action.predicate_overrides.desc": "Seçili koşullara göre bu modeli geçersiz kılacak modelleri seçin",
	"action.auto_set_cullfaces": "Görünmeyen Yüzleri Otomatik Ayarla",
	"action.auto_set_cullfaces.desc": "Komşu blok tarafından kaplandığında yüzleri gizlemek için otomatik olarak görünmeyen yüzler oluşturun.",
	"menu.texture.edit_externally": "Harici Olarak Düzenle",
	"menu.mirror_painting.texture": "2B Düzenleyici Simetrisi",
	"menu.mirror_painting.texture.desc": "Görüntü veya doku üzerinde 2B alanda ayna boyamayı etkinleştirin",
	"menu.animator.rotation_global": "Global Alanda Döndür",
	"uv_editor.face_properties": "Yüz Özellikleri",
	"uv_editor.face_properties.material_instance": "Malzeme Örneği",
	"uv_editor.tint.info": "Minecraft'a tonlamasını söylemek için bir yüzde tonlama etkinleştirilebilir. Vanilla'da tonlama yalnızca yapraklar ve redstone tozu gibi belirli bloklar tarafından kullanılabilir ve yalnızca 0 değerine sahip olabilir.",
	"uv_editor.cullface.info": "Görünmeyen yüz gizlemeyi etkinleştirmek, Minecraft dünyanızda yanına başka bir tam blok yerleştirildiğinde bir bloktaki bir yüzün renderlenmemesini söyler. Bu, performansı optimize etmek için kullanılabilir.",
	"uv_editor.material_instance.info": "Malzeme örnekleri kullanıcı tanımlı bir isme ayarlanabilir. Bu isim, davranış paketindeki blok JSON dosyasında yüze belirli bir doku ve malzeme atamak için kullanılabilir.",
	"display.reference.frame_invisible": "Eşya Çerçevesi (Görünmez)",
	"data.settings_profile": "Profil",
	"message.display_skin.invalid_name": "\"%0\" adına sahip Minecraft hesabı bulunamıyor.",
	"dialog.load_plugins_from_query.title": "Eklentileri Yükle",
	"dialog.load_plugins_from_query.text": "Eklentilerin yüklenmesini gerektiren bir bağlantı kullandınız. Bunları yüklemek ister misiniz?",
	"dialog.select_model.title": "Model Seç",
	"dialog.select_model.bones": "Kemikler",
	"dialog.select_model.cubes": "Küpler",
	"dialog.settings.create_profile": "Profil Oluştur...",
	"settings_profile.confirm_delete": "Bu ayarlar profilini silmek istediğinizden emin misiniz?",
	"settings_profile.condition.type.selectable": "Manuel Olarak Seçilebilir",
	"settings.interface_mode": "Kullanıcı Arayüzü Modu",
	"settings.interface_mode.desc": "Arayüz modu",
	"settings.interface_mode.auto": "Otomatik",
	"settings.interface_mode.desktop": "Masaüstü",
	"settings.interface_mode.mobile": "Mobil",
	"settings.paint_through_transparency": "Şeffaflıktan Boya",
	"settings.paint_through_transparency.desc": "Alfa Kanalını Kilitle etkinleştirildiğinde şeffaf piksellerin üzerinden boya",
	"action.tab_overview": "Sekme Genel Bakış",
	"action.tab_overview.desc": "Tüm açık sekmeleri bir ızgarada görüntüleyin ve birine atlayın",
	"action.slider_color_red": "Renk Kırmızı",
	"action.slider_color_green": "Renk Yeşil",
	"action.slider_color_blue": "Renk Mavi",
	"action.add_animation_controller": "Animasyon Kontrolcüsü Ekle",
	"action.add_animation_controller.desc": "Boş bir animasyon kontrolcüsü oluşturun",
	"action.animation_controller_preview_mode": "Kontrolcü Önizlemesi",
	"action.animation_controller_preview_mode.paused": "Duraklatıldı",
	"action.animation_controller_preview_mode.manual": "Manuel Önizleme",
	"action.animation_controller_preview_mode.play": "Otomatik Oynat",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Bézier Tutamaçlarını Bağla",
	"action.keyframe_bezier_linked.desc": "Sağ ve sol anahtar kare bézier tutamacını bağlayın",
	"action.reset_keyframe_handles": "Anahtar Kare Tutamaçlarını Sıfırla",
	"action.reset_keyframe_handles.desc": "Seçili anahtar karelerin bézier tutamaçlarını sıfırlayın",
	"action.looped_animation_playback": "Döngülü Oynatma",
	"action.looped_animation_playback.desc": "Animasyonları sonsuz bir döngüde önizleyin",
	"timeline.bind_to_actor": "Aktöre Bağla",
	"animation_controllers.select_preset": "Bir kontrolcü ön ayarı seçin...",
	"animation_controllers.state.animations": "Animasyonlar",
	"animation_controllers.state.particles": "Parçacıklar",
	"animation_controllers.state.sounds": "Sesler",
	"animation_controllers.state.on_entry": "Girişte",
	"animation_controllers.state.on_exit": "Çıkışta",
	"animation_controllers.state.transitions": "Geçişler",
	"animation_controllers.state.condition": "Koşul",
	"animation_controllers.state.blend_transition": "Karışım Süresi",
	"animation_controllers.state.shortest_path": "En Kısa Yoldan Karıştır",
	"animation_controllers.state.edit_transition": "Geçişi Düzenle",
	"menu.color_picker.picker_type": "Seçici Tipi",
	"menu.color_picker.picker_type.square": "Kare",
	"menu.color_picker.picker_type.wheel": "Tekerlek",
	"menu.color_picker.slider_mode": "Kaydırıcı Modu",
	"menu.color_picker.slider_mode.hsv": "Ton, Doygunluk, Değer",
	"menu.color_picker.slider_mode.rgb": "Kırmızı, Yeşil, Mavi",
	"menu.texture.render_mode.additive": "Toplanabilir",
	"panel.color.picker_options": "Renk Seçici Seçenekleri",
	"panel.animation_controllers": "Animasyon Kontrolcüsü",
	"display.preset.armor_stand": "Zemin (Zırh Standı)",
	"data.file_path": "Dosya Yolu",
	"dialog.extrude.orientation": "Yönelim",
	"dialog.extrude.orientation.upright": "Dik",
	"dialog.extrude.orientation.flat": "Düz",
	"dialog.scale.box_uv_warning": "Bir Kutu UV modelini ölçeklendirmek, modelinizin UV'sini bozabilir. Bunun yerine, modelinizi harici olarak ölçeklendirmeyi deneyin veya Dosya > Proje'de Yüz Başına UV Moduna geçin.",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Dizisi",
	"dialog.create_gif.pixelate": "Pikselleştir",
	"dialog.create_gif.bg_image": "Arka Plan Resmi",
	"dialog.create_gif.turn.desc": "Kayıt sırasında modeli döndürün. Modeli saat yönünde döndürmek için negatif değerler kullanın. 60 değeri saniyede bir dönüşe karşılık gelir.",
	"settings_profile.condition": "Koşul",
	"settings_profile.condition.type.file_path.desc": "Mevcut projenin dosya yoluyla eşleşmek için Normal İfade sözdizimini kullanın. Dizinler için eğik çizgi kullanın",
	"settings.only_selected_bezier_handles": "Yalnızca Seçili Bézier Tutamaçlarını Göster",
	"settings.only_selected_bezier_handles.desc": "Şu anda seçili olmayan bézier anahtar karelerinin tutamaçlarını gizle",
	"settings.embed_textures": "Dokuları Göm",
	"settings.embed_textures.desc": "Doku dosyası içeriğini .bbmodel dosyalarına göm",
	"action.selection_mode.cluster": "Küme",
	"dialog.copied_to_clipboard": "Panoya kopyalandı",
	"data.reference_image": "Referans Görseli",
	"message.delete_reference_image": "Bu referans görselini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
	"message.add_reference_image.message": "Referans görselinin nereye yükleneceğini seçin",
	"message.import_particle_texture.import": "Parçacık Dokusunu İçe Aktar",
	"message.import_particle_texture.message": "Parçacığınız için kullanılacak bir doku dosyasını içe aktarmak ister misiniz?",
	"message.save_codec_selector.title": "Model Biçimini Kaydet",
	"message.save_codec_selector.message": "Modeli kaydetmek için bir biçim seçin.",
	"message.save_codec_selector.project_file": "Blockbench Projesi (.bbmodel)",
	"message.save_codec_selector.both": "Her İkisi",
	"message.display_skin.username": "Kullanıcı Adı (Java)",
	"message.palette_locked": "Palet kilitli",
	"dialog.project.default_uv_mode": "Varsayılan UV Modu",
	"dialog.project.default_uv_mode.description": "Projenin varsayılan UV Modu. UV modu küp başına da değiştirilebilir.",
	"dialog.export_options.title": "Dışa Aktarma Seçenekleri",
	"dialog.edit_texture.preview": "Önizleme",
	"dialog.proportional_editing.range": "Aralık",
	"dialog.proportional_editing.falloff": "Azalma",
	"dialog.proportional_editing.falloff.linear": "Doğrusal",
	"dialog.proportional_editing.falloff.hermite_spline": "Yumuşak",
	"dialog.proportional_editing.falloff.constant": "Sabit",
	"dialog.proportional_editing.selection": "Seçim",
	"dialog.proportional_editing.selection.linear": "Doğrusal Mesafe",
	"dialog.proportional_editing.selection.connections": "Bağlantılar",
	"dialog.mirror_painting_texture_center.middle": "Orta",
	"dialog.mirror_painting_texture_center.custom": "Özel",
	"dialog.settings.reset_to_default": "Varsayılana Sıfırla",
	"keybindings.item.num_slider.increase": "Arttır",
	"keybindings.item.num_slider.decrease": "Azalt",
	"settings.always_show_splash_art": "Açılış Sanatını Her Zaman Göster",
	"settings.always_show_splash_art.desc": "Başlangıç ekranında açılış sanatını her zaman göster",
	"action.slider_palette_color": "Palet Rengini Değiştir",
	"action.slider_palette_color.desc": "Paletteki renkler arasında geçiş yapın",
	"action.proportional_editing": "Orantılı Düzenleme",
	"action.proportional_editing.desc": "Bir ağın parçalarını düzenlerken çevredeki tepe noktalarını orantılı olarak etkileyin",
	"action.limit_to_palette": "Palete Sınırla",
	"action.limit_to_palette.desc": "Dokunun renklerini şu anda yüklü olan paletteki renklere sınırlar",
	"action.edit_reference_images": "Referans Görsellerini Düzenle",
	"action.edit_reference_images.desc": "Referans görselleri ve planları eklemek veya düzenlemek için referans görsel modunu açın",
	"action.add_reference_image": "Referans Görseli Ekle",
	"action.reference_image_from_clipboard": "Panodan Referans Görseli",
	"action.reference_image_list": "Referans Görselleri",
	"action.connect_uv_faces": "UV Yüzlerini Bağla",
	"action.connect_uv_faces.desc": "Seçili UV yüzlerini son seçilen UV yüzüne bağlayın",
	"action.merge_uv_vertices": "UV Tepe Noktalarını Birleştir",
	"action.merge_uv_vertices.desc": "İlk seçilen UV tepe noktalarını son seçilen UV tepe noktalarına yaslayın",
	"action.bedrock_animation_mode": "Bedrock Animasyon Modu",
	"action.bedrock_animation_mode.desc": "Minecraft: Bedrock Sürümü için animasyonları düzenleme modunu seçin",
	"action.bedrock_animation_mode.entity": "Varlık",
	"action.bedrock_animation_mode.attachable_first": "Öğe 1. Şahıs",
	"action.bedrock_animation_mode.attachable_third": "Öğe 3. Şahıs",
	"timeline.amplify": "Güçlendir",
	"menu.options": "Seçenekler...",
	"menu.palette.lock_palette": "Paleti Kilitle",
	"menu.uv.export": "UV Haritasını Dışa Aktar",
	"menu.uv.flip_x": "X'i Aynala",
	"menu.uv.flip_y": "Y'yi Aynala",
	"menu.mirror_painting.enabled": "Etkin",
	"reference_image.position": "Pozisyon",
	"reference_image.size": "Boyut",
	"reference_image.rotation": "Döndürme",
	"reference_image.opacity": "Opaklık",
	"reference_image.visibility": "Görünürlük",
	"reference_image.clear_mode": "Temizleme Modu",
	"reference_image.layer": "Katman",
	"reference_image.layer.background": "Modelin Arkasında",
	"reference_image.layer.viewport": "Modelin Üstünde",
	"reference_image.layer.float": "Arayüzün Üstünde",
	"reference_image.scope": "Kapsam",
	"reference_image.scope.project": "Sadece bu proje",
	"reference_image.scope.global": "Tüm projeler",
	"reference_image.enabled_modes": "Modlarda Etkin",
	"codec.common.encoding": "Kodlama",
	"codec.common.armature": "Grupları İskelet Olarak Dışa Aktar",
	"codec.common.export_animations": "Animasyonları Dışa Aktar",
	"codec.common.embed_textures": "Dokuları Göm",
	"preview.center_camera": "Kamerayı Ortala",
	"display.reference.frame_top": "Eşya Çerçevesi Üst",
	"display.reference.frame_top_invisible": "Eşya Çerçevesi Üst (Görünmez)",
	"action.proportional_editing_range": "Orantılı Düzenleme Aralığı",
	"action.proportional_editing_range.desc": "Orantılı düzenleme aralığını ayarlayın",
	"action.toggle_all_reference_images": "Tüm Referans Görsellerini Gizle/Göster",
	"action.toggle_all_reference_images.desc": "Tüm referans görsellerinin görünürlüğünü aynı anda aç/kapat",
	"action.add_animation_controller_state": "Animasyon Kontrolcüsü Durumu Ekle",
	"action.add_animation_controller_state.desc": "Animasyon kontrolcüsüne yeni bir durum ekleyin",
	"menu.slider.round_value": "Değeri Yuvarla",
	"texture.error.too_large": "Çözünürlük %0 maksimumunu aşıyor",
	"dialog.copy_to_clipboard": "Panoya kopyala",
	"dialog.open_url": "URL'yi Aç",
	"reference_image.image": "Görsel",
	"uv_editor.rotate_uv": "UV'yi Döndür",
	"generic.error": "Hata",
	"projects.start_screen": "Başlangıç Ekranı",
	"message.invalid_link.message": "Yüklemeye çalıştığınız paylaşılan model \"%0\" geçersiz veya süresi dolmuş.",
	"message.plugin_dependencies.title": "Eklenti Bağımlılıkları",
	"message.plugin_dependencies.message1": "Eklenti şu bağımlılıkları gerektirir:",
	"message.plugin_dependencies.message1_update": "%0 eklentisi güncellendi ve şimdi şu bağımlılıkları gerektiriyor:",
	"message.plugin_dependencies.message2": "Devam etmek için bunları yüklemek istiyor musunuz?",
	"message.plugin_dependencies.invalid": "Maalesef eklenti yüklenemiyor, geçersiz bir bağımlılığı var:",
	"message.preview_scene_load_failed": "Önizleme sahnesi yüklenemedi. İnternet bağlantınızı kontrol edin.",
	"dialog.convert_project.text1": "Projeyi farklı bir formata dönüştür.",
	"dialog.convert_project.text2": "Dönüşümü kendi sorumluluğunuzda kullanın. Formatların farklı özellikleri ve kısıtlamaları vardır, bu nedenle dönüştürme bazı durumlarda projenizin bazı kısımlarını bozabilir.",
	"dialog.convert_project.text3": "Dönüştürmeyi geri alamazsınız, bu nedenle varsayılan olarak bir kopya oluşturulacaktır.",
	"dialog.unsaved_work.title": "Kaydedilmemiş Çalışma",
	"dialog.unsaved_work.text": "Aşağıdaki projeler kaydedilmemiş değişiklikler içeriyor. Değişikliklerinizi kaydetmek istiyor musunuz?",
	"dialog.unsaved_work.discard_all": "Tümünden Vazgeç",
	"dialog.unsaved_work.save_all": "Tümünü Kaydet",
	"dialog.resize_texture.mode": "Mod",
	"dialog.resize_texture.mode.crop": "Kırp/Genişlet",
	"dialog.resize_texture.mode.scale": "Ölçeklendir",
	"dialog.plugins.is_installed": "Yüklü",
	"dialog.plugins.is_disabled": "Devre Dışı",
	"dialog.plugins.disable": "Devre Dışı Bırak",
	"dialog.plugins.enable": "Etkinleştir",
	"dialog.plugins.dependencies": "Bağlı olduğu:",
	"dialog.view_backups.open_folder": "Klasörü Aç",
	"dialog.share_model.reference_images": "Referans Görsellerini Dahil Et",
	"dialog.share_model.too_large": "Yüklenemedi: Model çok büyük",
	"dialog.share_model.too_large_references": "Yüklenemedi: Model çok büyük. Referans görselleri olmadan deneyin.",
	"settings.stretch_linked": "Uzatmayı Bağla",
	"settings.stretch_linked.desc": "Küpü tüm yönlerde aynı değerle uzat",
	"settings.grids": "Izgaraları Göster",
	"settings.grids.desc": "Tüm 3B ızgaraları göster veya gizle",
	"settings.double_click_switch_tools": "Çift Tıklamada Araçları Değiştir",
	"settings.double_click_switch_tools.desc": "Araçlar arasında geçiş yapmak için görünüm alanına çift tıklayın",
	"settings.outlines_in_paint_mode": "Boya Modunda Seçim Anahatları",
	"settings.outlines_in_paint_mode.desc": "Boya modundayken öğe seçim anahatlarını görüntüle",
	"settings.json_indentation": "JSON Girintileme",
	"settings.json_indentation.desc": "Dışa aktarılan JSON dosyaları için girintileme stili",
	"settings.json_indentation.tabs": "Sekmeler",
	"settings.json_indentation.spaces_4": "Boşluklar: 4",
	"settings.json_indentation.spaces_2": "Boşluklar: 2",
	"action.slider_stretch": "Uzat",
	"action.slider_stretch.desc": "UV'yi değiştirmeden küpleri %0 ekseninde çarpımsal olarak uzatır",
	"action.view_backups": "Yedekleri Görüntüle",
	"action.view_backups.desc": "Otomatik kaydedilen proje yedekleri listesine göz atın",
	"action.search_outliner": "Anahatta Ara",
	"action.search_outliner.desc": "Anahatta belirli öğe adlarını arayın",
	"action.mirror_modeling": "Ayna Modelleme",
	"action.mirror_modeling.desc": "X ekseninde Ayna Modellemeyi etkinleştirin. Görünüm alanında yaptığınız tüm değişiklikler, öğede özellikle devre dışı bırakılmadıkça diğer tarafa yansıtılacaktır.",
	"action.allow_element_mirror_modeling": "Ayna Modellemeye İzin Ver",
	"action.allow_element_mirror_modeling.desc": "Seçili öğelerin ayna modellemeden etkilenip etkilenmeyeceğini seçin",
	"action.switch_face_crease": "Yüz Kırışıklığını Değiştir",
	"action.switch_face_crease.desc": "Dörtgenin ortada hangi yönde katlandığını değiştirin",
	"action.clear_unused_texture_space": "Kullanılmayan Doku Alanını Temizle",
	"action.clear_unused_texture_space.desc": "Herhangi bir öğeye UV haritalanmamış doku parçalarını temizleyin",
	"action.split_screen": "Ekranı Böl",
	"action.split_screen.desc": "Bir görünüm alanı ekran bölme modu seçin",
	"action.split_screen.single": "Tek",
	"action.split_screen.double_horizontal": "Çift Yatay",
	"action.split_screen.double_vertical": "Çift Dikey",
	"action.split_screen.quad": "Dörtlü",
	"action.split_screen.triple_left": "Üçlü Sol",
	"action.split_screen.triple_right": "Üçlü Sağ",
	"action.split_screen.triple_top": "Üçlü Üst",
	"action.split_screen.triple_bottom": "Üçlü Alt",
	"action.uv_project_from_view": "Görünümden UV Projeksiyonu",
	"action.uv_project_from_view.desc": "3B görünüm perspektifinden seçili yüzler için otomatik olarak UV oluşturun",
	"action.graph_editor_other_graphs": "Diğer Grafikleri Görüntüle",
	"action.graph_editor_other_graphs.desc": "Seçili olmayan eksenlerin grafiklerinin görüntülenip görüntülenmediği",
	"action.graph_editor_include_other_graphs": "Diğer Grafikleri Dahil Et",
	"action.graph_editor_include_other_graphs.desc": "Grafik düzenleyicinin görünümde seçili olmayan grafikleri içerip içermediği",
	"action.set_ik_source": "IK Kökünü Ayarla",
	"action.set_ik_source.desc": "Bu boş nesne tarafından Ters Kinematik aracılığıyla taşınması gereken zincirin kök kemiğini seçin",
	"edit.loop_cut.cuts": "Kesikler",
	"panel.element.stretch": "Uzat",
	"preview_scene.minecraft_plains": "Ovalar",
	"preview_scene.minecraft_cherry_grove": "Kiraz Korusu",
	"preview_scene.minecraft_snowy_tundra": "Karlı Tundra",
	"preview_scene.minecraft_sunset": "Gün Batımı",
	"preview_scene.minecraft_night": "Gece",
	"preview_scene.minecraft_desert": "Çöl",
	"preview_scene.minecraft_underwater": "Sualtı",
	"preview_scene.minecraft_coral_reef": "Mercan Resifi",
	"preview_scene.minecraft_lush_cave": "Yemyeşil Mağara",
	"preview_scene.minecraft_deep_dark": "Derin Karanlık",
	"generic.navigate_forward": "İleri",
	"generic.navigate_back": "Geri",
	"action.element_render_order": "Şeffaflık İşleme Sırası",
	"action.element_render_order.default": "Otomatik",
	"action.element_render_order.behind": "Arkada",
	"action.element_render_order.in_front": "Önde",
	"message.installing_update.title": "Güncelleme Mevcut",
	"message.installing_update.message": "Yeni bir sürüm yüklenmeye hazır. Uygulamayı kapattıktan sonra, güncellemenin yüklenmesi için Blockbench'i tekrar açmadan veya bilgisayarı kapatmadan önce lütfen yaklaşık %0 saniye bekleyin.",
	"settings.brush_cursor_2d": "2B Fırça İmleci",
	"settings.brush_cursor_2d.desc": "2B çalışma alanında fırçanın etrafında bir anahat görüntüle",
	"settings.brush_cursor_3d": "3B Fırça İmleci",
	"settings.brush_cursor_3d.desc": "3B çalışma alanında fırçanın etrafında bir anahat görüntüle",
	"settings.cdn_mirror": "CDN Aynası Kullan",
	"settings.cdn_mirror.desc": "Eklentileri indirmek için ayna CDN'yi kullanın. Ayna, güncellemeleri daha hızlı alır ve varsayılanın çalışmadığı bazı bölgelerde çalışır.",
	"data.layer": "Katman",
	"data.panel": "Panel",
	"generic.confirm_delete": "Bunu silmek istediğine emin misin?",
	"format_category.general": "Genel",
	"modifier_actions.no_uniform_scaling": "Serbest Ölçeklendirme",
	"message.texture_refresh_conflict.title": "Çakışan Doku Sürümleri",
	"message.texture_refresh_conflict.message": "Doku dosyası, Blockbench'in sürümüyle çakışan değişiklikler içerebilir",
	"message.texture_refresh_conflict.keep_ours": "Blockbench'in sürümünü koru",
	"message.texture_refresh_conflict.keep_theirs": "Dosyayı yükle ve Blockbench'teki tüm değişiklikleri ve katmanları at",
	"message.group_required_to_animate": "Bu tür bir öğeyi canlandıramazsınız. Canlandırmak için bir grup oluşturun.",
	"dialog.texture.uv_size": "UV Boyutu",
	"dialog.advanced_screenshot.angle_preset": "Açı Ön Ayarı",
	"dialog.advanced_screenshot.resolution": "Çözünürlük",
	"dialog.advanced_screenshot.zoom_to_fit": "Sığacak Şekilde Yakınlaştır",
	"dialog.advanced_screenshot.zoom": "Yakınlaştırma / Odak Uzaklığı",
	"dialog.advanced_screenshot.anti_aliasing": "Kenar Yumuşatma",
	"dialog.advanced_screenshot.anti_aliasing.off": "Kapalı",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Çoklu Örnekleme",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Süper Örnekleme",
	"dialog.advanced_screenshot.show_gizmos": "Düzenleme Yardımcılarını Göster",
	"dialog.advanced_screenshot.shading": "Gölgelendirme",
	"settings.auto_keyframe": "Otomatik Anahtar Kare",
	"settings.auto_keyframe.desc": "Kemiği daha sonraki bir noktada dönüştürürken zaman çizelgesi başlangıcında otomatik olarak varsayılan değerlerle bir anahtar kare oluştur",
	"settings.modded_entity_integer_size": "Modlu Varlık Tamsayı Boyutu",
	"settings.modded_entity_integer_size.desc": "Modlu Varlık formatındaki küp boyutlarını tamsayılarla sınırlayın. Kayan noktalı sayılar bazı sürümlerde teknik olarak desteklense de, tamsayıların UV haritasını çıkarmak çok daha kolaydır.",
	"category.layers": "Katmanlar",
	"keybind.paint_secondary_color": "İkincil Renkle Boya",
	"action.selection_tool_operation_mode": "Seçim İşlemi Modu",
	"action.selection_tool_operation_mode.create": "Yeni Seçim",
	"action.selection_tool_operation_mode.add": "Seçime Ekle",
	"action.selection_tool_operation_mode.subtract": "Seçimden Çıkar",
	"action.selection_tool_operation_mode.intersect": "Kesiştir",
	"action.pixel_perfect_drawing": "Piksel Mükemmel Çizim",
	"action.pixel_perfect_drawing.desc": "Eğrilerde çift piksel olmadan pürüzsüz piksel sanat çizgileri çizin",
	"action.selection_tool": "Seçim Aracı",
	"action.selection_tool.desc": "Görüntünün parçalarını seç",
	"action.selection_tool.rectangle": "Dikdörtgen",
	"action.selection_tool.ellipse": "Elips",
	"action.selection_tool.lasso": "Kement Seçimi",
	"action.selection_tool.wand": "Sihirli Değnek",
	"action.selection_tool.color": "Aynı Renk",
	"action.move_layer_tool": "Katmanı Taşı",
	"action.move_layer_tool.desc": "Mevcut katmanı veya seçimi taşı",
	"action.export_modded_animations": "Modlu Varlık Animasyonlarını Dışa Aktar",
	"action.export_modded_animations.desc": "Bir Minecraft Java Sürümü modlu varlık modeli için animasyonları dışa aktarın",
	"action.swap_colors": "Renkleri Değiştir",
	"action.swap_colors.desc": "Ana rengi ikincil renkle değiştirin",
	"action.apply_mesh_rotation": "Döndürmeyi Uygula",
	"action.apply_mesh_rotation.desc": "Ağın öğe döndürmesini sıfırlayın ve bunun yerine geometriye uygulayın",
	"action.flip_texture_x.desc": "Dokuyu veya katmanı yatay olarak çevirin",
	"action.flip_texture_y.desc": "Dokuyu veya katmanı dikey olarak çevirin",
	"action.rotate_texture_cw.desc": "Dokuyu veya katmanı saat yönünde döndürün",
	"action.rotate_texture_ccw.desc": "Dokuyu veya katmanı saat yönünün tersine döndürün",
	"action.crop_texture_to_selection": "Dokuyu Seçime Kırp",
	"action.create_empty_layer": "Boş Katman Oluştur",
	"action.enable_texture_layers": "Katmanları Etkinleştir",
	"action.disable_texture_layers": "Katmanları Devre Dışı Bırak",
	"action.layer_opacity": "Katman Opaklığı",
	"action.layer_to_texture_size": "Katmanı Doku Boyutuna Genişlet",
	"action.layer_to_texture_size.desc": "Katmanı dokunun boyutuna genişletin",
	"action.merge_layer_down": "Aşağı Birleştir",
	"action.merge_layer_down.desc": "Aşağıdaki katmana birleştirin",
	"action.advanced_screenshot": "Gelişmiş Ekran Görüntüsü...",
	"action.advanced_screenshot.desc": "Gelişmiş seçeneklerle modelin bir ekran görüntüsünü alın",
	"action.bake_ik_animation": "Ters Kinematik Pişir",
	"action.bake_ik_animation.desc": "Ters kinematik tarafından uygulanan döndürmeleri seçili animasyona pişirin",
	"action.save_animation_preset": "Animasyon Ön Ayarını Kaydet...",
	"action.save_animation_preset.desc": "Seçili anahtar kareleri bir animasyon ön ayarı olarak kaydedin",
	"action.animation_onion_skin": "Animasyon Soğan Zarı",
	"action.animation_onion_skin.desc": "Referans için animasyonda farklı bir karenin tel kafes görünümünü görüntüleyin",
	"action.apply_animation_preset": "Animasyon Ön Ayarını Uygula",
	"action.apply_animation_preset.desc": "Animasyon ön ayarları listesinden seçim yapın ve seçili kemiğe uygulayın",
	"menu.brush_presets.pixel_perfect": "Piksel Mükemmel Fırça",
	"panel.layers": "Katmanlar",
	"uv_editor.copy_paste_tool.to_layer": "Yeni Katmana",
	"format.image.new": "Yeni Görsel Oluştur",
	"format.image.info.summary": "2B Görsel düzenleyici, Blockbench içinde doğrudan görsel ve piksel sanatı oluşturmanıza ve düzenlemenize olanak tanır. Görselleri düzenleyin, dokuları değiştirin veya kendi piksel sanatınızı oluşturun!",
	"settings.move_with_selection_tool": "Seçimleri Taşımak için Seçim Aracını Kullan",
	"settings.move_with_selection_tool.desc": "Seçim Aracının, Taşıma Katmanı aracına geçmek zorunda kalmadan seçimleri doğrudan taşımasına izin ver",
	"settings.final_newline": "Son Yeni Satır",
	"settings.final_newline.desc": "Dışa aktarılan dosyaların sonuna bir yeni satır karakteri ekle",
	"action.crop_layer_to_selection": "Katmanı Seçime Kırp",
	"action.edit_mode_uv_overlay.desc": "UV haritasını düzenleme modunda bir kaplama olarak görüntüleyin",
	"menu.image": "Görsel",
	"menu.texture.discard_changes": "Değişikliklerden Vazgeç",
	"menu.texture.discard_changes.desc": "Tüm kaydedilmemiş değişikliklerden vazgeçin ve dosyadan en son sürümü yükleyin",
	"panel.textures.images": "Görseller",
	"dialog.advanced": "Gelişmiş",
	"dialog.recommended_option": "önerilen",
	"modifier_actions.snap_to_center": "Merkeze Yasla",
	"modifier_actions.snap_to_pixels": "Piksellere Yasla",
	"message.invalid_format.install_plugin": "'%0' eklentisini yükle",
	"message.plugin_deprecated.message": "Bu kullanımdan kaldırılmış eklentiyi yüklemek istediğinizden emin misiniz?",
	"message.plugin_deprecated.install_anyway": "Yine de Yükle",
	"message.image_editor.not_found": "Seçilen resim düzenleyici bulunamadı. Lütfen farklı bir seçenek seçin.",
	"message.knife_tool.confirm": "Bıçak Aracını uygulamak için %0'a basın veya buraya tıklayın",
	"message.knife_tool.skipped_face": "Farklı yüzler arasında kesim yapılamaz. Aralarındaki kenarları veya tepe noktalarını dahil edin!",
	"message.optimize_animation.keyframes_removed": "%0 gereksiz anahtar kare kaldırıldı",
	"message.optimize_animation.nothing_to_optimize": "Optimize edilecek bir şey bulunamadı!",
	"message.duplicate_bone_copy_animation.title": "Animasyonu Kopyala",
	"message.duplicate_bone_copy_animation.message": "Yinelenen kemik %0 animasyonda canlandırılıyor. Anahtar kareleri yeni kemiğe kopyalamak istiyor musunuz?",
	"message.auto_fix_mesh_edit.title": "Otomatik Düzelt",
	"message.auto_fix_mesh_edit.revert": "Düzenlemeyi Geri Al",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Belirli tepe noktaları aynı noktaya taşındı. Nasıl devam etmek istersiniz?",
	"message.auto_fix_mesh_edit.concave_quads": "Bir veya daha fazla dörtlü yüz artık içbükey, bu da UV haritalama ve renderlemede sorunlara neden olabilir. Blockbench bunu sizin için otomatik olarak düzeltebilir:",
	"message.auto_fix_mesh_edit.merge_vertices": "Tepe Noktalarını Birleştir",
	"message.auto_fix_mesh_edit.split_quads": "Dörtlüleri Böl",
	"message.load_images.add_image": "Görsel Ekle",
	"dialog.project.modded_entity_entity_class": "Varlık Sınıfı",
	"dialog.resize_texture.offset": "Ofset",
	"dialog.animated_texture_editor.code_reference": "Kod Referansı",
	"dialog.animated_texture_editor.code_reference.about": "Doku animasyonunu uygulamak için bu kod bir referans olarak oluşturulmuştur ve değiştirilmeden mutlaka çalışmayabilir. Daha fazla bilgi edinmek için belgelere göz atın.",
	"dialog.animated_texture_editor.code_reference.docs": "Belgeler",
	"dialog.animated_texture_editor.reframe": "Yeniden Çerçevele",
	"dialog.animated_texture_editor.stride": "Kare Boyutu",
	"dialog.animated_texture_editor.frames": "Kare Sayısı",
	"dialog.animated_texture_editor.add_frame": "Kare Ekle",
	"dialog.animated_texture_editor.resize_frames": "Kareleri Yeniden Boyutlandır...",
	"dialog.animated_texture_editor.apply": "Uygula",
	"dialog.add_primitive.edge_size": "Kenar Boyutu",
	"dialog.change_animation_speed.speed": "Hız",
	"dialog.change_animation_speed.adjust_snapping": "Yaslamayı Ayarla",
	"dialog.optimize_animation.selection": "Seçim",
	"dialog.optimize_animation.selection.selected_keyframes": "Seçili Anahtar Kareler",
	"dialog.optimize_animation.selection.selected_animation": "Seçili Animasyon",
	"dialog.optimize_animation.selection.all_animations": "Tüm Animasyonlar",
	"dialog.optimize_animation.thresholds": "Eşik değerleri",
	"dialog.import_obj.obj": "OBJ Dosyası",
	"dialog.import_obj.mtl": "MTL Dosyası",
	"dialog.import_obj.scale": "Ölçek",
	"layout.thumbnail": "Özel Küçük Resim CSS'i",
	"settings.pixel_grid": "Piksel Izgarası",
	"settings.pixel_grid.desc": "Düzenleme modunda öğeler üzerinde doku piksel ızgarasını göster",
	"settings.image_editor_grid_size": "Görsel Düzenleyici Izgara Boyutu",
	"settings.image_editor_grid_size.desc": "2B görsel düzenleyicideki büyük ızgaranın boyutu",
	"settings.ground_plane_double_side": "Çift Taraflı Zemin Düzlemi",
	"settings.ground_plane_double_side.desc": "Zemin düzlemini aşağıdan görünür yap",
	"settings.optifine_save_default_texture": "OptiFine JEM: Seçili dokuyu dışa aktar",
	"settings.optifine_save_default_texture.desc": "Seçili dokuyu modelin varsayılan dokusu olarak dışa aktar",
	"action.slider_color_select_threshold": "Renk Seçim Eşiği",
	"action.slider_color_select_threshold.desc": "Komşu bir pikselin renginin renk veya sihirli değnek seçimiyle seçilmesi için ne kadar yakın olması gerektiği",
	"action.stretch_tool": "Uzat",
	"action.stretch_tool.desc": "Öğeleri seçme ve uzatma aracı",
	"action.knife_tool": "Bıçak Aracı",
	"action.knife_tool.desc": "Ağ yüzlerini daha küçük parçalara kesme aracı",
	"action.duplicate_project": "Projeyi Çoğalt",
	"action.duplicate_project.desc": "Açık projenin bir kopyasını oluşturur",
	"action.transform_space.parent": "Üst",
	"action.transform_pivot_space": "Merkez Dönüşüm Alanı",
	"action.solidify_mesh_selection": "Yüzleri Katılaştır",
	"action.solidify_mesh_selection.desc": "Ağın seçili yüzlerini katılaştırın",
	"action.animated_texture_editor": "Flipbook Animasyonu...",
	"action.animated_texture_editor.desc": "Seçili dokunun flipbook animasyonunu kurun veya düzenleyin",
	"action.center_individual_pivots": "Bireysel Merkezleri Ortala",
	"action.center_individual_pivots.desc": "Seçili her öğenin merkez noktasını kendi merkezine ayarlayın",
	"action.uv_cycle": "UV Döngüsü",
	"action.uv_cycle.desc": "UV konumlarını değiştirmeden UV tepe noktaları sırası arasında geçiş yapın",
	"action.uv_cycle_invert": "Ters UV Döngüsü",
	"action.uv_cycle_invert.desc": "UV konumlarını değiştirmeden UV tepe noktaları sırasını tersine çevirin",
	"action.slider_animation_controller_speed": "Kontrolcü Oynatma Hızı",
	"action.slider_animation_controller_speed.desc": "Yüzde olarak animasyon kontrolcülerinin oynatma hızı",
	"action.optimize_animation": "Animasyonu Optimize Et",
	"action.optimize_animation.desc": "Mevcut animasyonu optimize edin ve anahtar kare sayısını azaltın",
	"action.change_animation_speed": "Animasyon Hızını Değiştir...",
	"action.change_animation_speed.desc": "Seçili animasyonun hızını değiştirin",
	"timeline.select_particle_file": "Parçacık Dosyası Seç",
	"timeline.select_sound_file": "Ses Dosyası Seç",
	"menu.cube.texture.default": "Varsayılan",
	"menu.texture.particle.clear": "Parçacıklar için Kullanmayı Bırak",
	"menu.texture.use_as_default": "Varsayılan Olarak Ayarla",
	"menu.texture.use_as_default.clear": "Varsayılan Olarak Atamayı Kaldır",
	"menu.toolbar.overflow": "Araç Çubuğu Taşması",
	"edit.solidify_mesh_selection.thickness": "Kalınlık",
	"reference_image.sync_to_timeline": "Zaman Çizelgesine Senkronize Et",
	"reference_image.toggle_playback": "Oynat/Duraklat",
	"dialog.add_primitive.shape.beveled_cuboid": "Eğimli Küboid",
	"dialog.ignore_all": "Tümünü Yoksay",
	"data.texture_group": "Doku Grubu",
	"data.animation": "Animasyon",
	"generic.on": "Açık",
	"generic.off": "Kapalı",
	"format.free.info.3d_printing": "3B Yazdırma",
	"message.invalid_file.merge_conflict": "Dosya, çözülmemiş Git birleştirme çakışmaları içeriyor.",
	"dialog.expand_texture_selection.radius": "Miktar",
	"dialog.expand_texture_selection.corner": "Köşe Şekli",
	"dialog.expand_texture_selection.corner.round": "Yuvarlak",
	"dialog.expand_texture_selection.corner.square": "Kare",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "İçine Birleştir",
	"keybindings.variation_conflict": "Varyasyon, ana tuş atamasıyla çakışıyor",
	"settings.recovery_save_interval": "Kurtarma Noktası Kaydetme Aralığı",
	"settings.recovery_save_interval.desc": "Blockbench, bir bilgisayar çökmesi durumunda kurtarmak için açık projeyi arka planda düzenli olarak kaydeder. Aralığı saniye cinsinden ayarlayın. Kaydetmeyi devre dışı bırakmak için 0'a ayarlayın.",
	"settings.save_view_per_tab": "Görünümü Sekme Başına Kaydet",
	"settings.save_view_per_tab.desc": "Mevcut görünüm açısını her sekme için ayrı ayrı kaydet",
	"settings.inherit_parent_color": "Üst Rengini Devral",
	"settings.inherit_parent_color.desc": "Yeni oluşturulan bir öğenin işaretleyici rengini rastgele bir renk yerine üst öğenin rengine ayarlayın",
	"keybind.preview_select.multi_select": "Çoklu seç",
	"keybind.preview_select.group_select": "Grup seç",
	"keybind.preview_select.loop_select": "Döngü seç",
	"action.fill_mode.selection": "Seçim",
	"action.fill_mode.selected_elements": "Seçili Öğeler",
	"action.image_tiled_view": "Döşenmiş Görünüm",
	"action.image_tiled_view.description": "2B düzenleyicide döşenmiş görünümü etkinleştir",
	"action.image_onion_skin_view": "Görsel Düzenleyici Soğan Zarı",
	"action.image_onion_skin_view.description": "2B düzenleyicide soğan zarı görünümünü etkinleştir",
	"action.expand_texture_selection": "Doku Seçimini Genişlet",
	"action.expand_texture_selection.desc": "Doku seçimini genişlet veya daralt",
	"action.switch_tabs.reverse_order": "Ters sıra",
	"action.save_project_incremental": "Projeyi Artımlı Olarak Kaydet",
	"action.save_project_incremental.desc": "Mevcut modeli artımlı olarak bir proje dosyası olarak kaydeder (ör: proje_2.bbmodel)",
	"action.copy.multiple": "Tümünü Kopyala",
	"action.copy.multiple.desc": "Mevcut tüm verileri ayrı ayrı kopyalayın",
	"action.paste.multiple": "Tümünü Yapıştır",
	"action.randomize_marker_colors": "İşaretleyici Renklerini Rastgeleleştir",
	"action.cube_light_emission": "Işık Emisyonu",
	"action.cube_light_emission.desc": "Seçili küplerin yayıcılığını 0 ile 15 arasında bir değer olarak değiştirin",
	"action.view_mode.colored_solid": "İşaretleyici Renkleriyle Katı",
	"action.focus_on_selection.rotate_only": "Yalnızca döndür",
	"action.create_texture_group": "Doku Grubu Oluştur",
	"action.create_texture_group.desc": "Dokularınız için bir grup oluşturun",
	"action.uv_maximize.all_faces": "Tüm yüzleri etkile",
	"action.retarget_animators": "Animasyonları Yeniden Hedefle",
	"action.retarget_animators.desc": "Hangi animatörün hangi kemiği veya öğeyi hedeflediğini seçin",
	"action.merge_animation": "Animasyonu Birleştir",
	"action.merge_animation.desc": "Animasyonu başka bir animasyona birleştirin",
	"action.add_keyframe.reset_values": "Varsayılan değerlerle",
	"action.set_timeline_range_start": "Zaman Çizelgesi Aralığı Başlangıcını Ayarla",
	"action.set_timeline_range_start.desc": "Animasyon zaman çizelgesinde özel bir oynatma aralığı için başlangıç noktasını ayarlayın",
	"action.set_timeline_range_end": "Zaman Çizelgesi Aralığı Sonunu Ayarla",
	"action.set_timeline_range_end.desc": "Animasyon zaman çizelgesinde özel bir oynatma aralığı için bitiş noktasını ayarlayın",
	"action.disable_timeline_range": "Zaman Çizelgesi Aralığını Devre Dışı Bırak",
	"action.disable_timeline_range.desc": "Animasyon zaman çizelgesindeki özel oynatma aralığını devre dışı bırakın",
	"menu.texture_group.resolve": "Çöz",
	"menu.image_tiled_view.mirrored": "Aynalı Kenarlar",
	"menu.image_onion_skin_view.frame": "Kareler",
	"menu.image_onion_skin_view.frame.last_viewed": "Son Görüntülenen Kare",
	"menu.image_onion_skin_view.frame.previous": "Önceki Kare",
	"menu.image_onion_skin_view.frame.next": "Sonraki Kare",
	"menu.image_onion_skin_view.frame.both": "Önceki + Sonraki",
	"menu.image_onion_skin_view.display": "Görüntü",
	"menu.image_onion_skin_view.display.pixels": "Daha Küçük Pikseller",
	"menu.image_onion_skin_view.display.transparent": "Şeffaf",
	"menu.image_onion_skin_view.above": "Yukarıda Görüntüle",
	"menu.animation.reload": "Yeniden Yükle",
	"switches.autouv.alt": "Göreceli",
	"display.rotation_pivot": "Döndürme Merkezi",
	"display.scale_pivot": "Ölçek Merkezi",
	"display.reference.fox": "Tilki",
	"display.reference.eating": "Yemek Yeme",
	"preview_scene.sky": "Gökyüzü",
	"preview_scene.space": "Uzay",
	"preview_scene.minecraft_ocean": "Okyanus",
	"message.import_palette.selection_only": "Yalnızca seçim",
	"dialog.blend_transition_edit.ease_in_out": "Yavaşlama-Hızlanma (%0)",
	"dialog.blend_transition_edit.generate": "Oluştur...",
	"dialog.blend_transition_edit.generate.learn_more": "Daha fazla bilgi ve önizleme",
	"dialog.blend_transition_edit.generate.curve": "Yumuşatma Tipi",
	"dialog.blend_transition_edit.generate.steps": "Anahtar Kareler",
	"settings.fps_limit": "FPS Sınırı",
	"settings.fps_limit.desc": "Blockbench'in saniyede kaç kare işleyeceğini sınırlayın. Gerçek kare hızı, cihazınızın görüntüleyebileceği ile sınırlıdır.",
	"settings.outliner_reveal_on_select": "Seçimde Öğeleri Göster",
	"settings.outliner_reveal_on_select.desc": "Seçildiğinde anahatta öğeleri göster",
	"settings.java_export_pivots": "Java blok/öğe modellerinde Merkez Noktalarını Dışa Aktar",
	"settings.java_export_pivots.desc": "Döndürme olmadan küplerde Java blok/öğe modellerinde merkez noktalarını kaydet",
	"animation_controllers.state.blend_transition_curve": "Karışım Geçiş Eğrisi",
	"menu.slider.reset_vector": "Vektörü Sıfırla",
	"dialog.blend_transition_edit.extended": "Genişletilmiş Grafik",
	"message.screenshot_too_large.title": "Ekran Görüntüsü Çözünürlük Sorunu",
	"message.screenshot_too_large.message": "Ekran görüntüsü başarılı bir şekilde oluşturulamadı. Lütfen daha düşük bir çözünürlükle veya süper örnekleme olmadan tekrar deneyin.",
	"message.rename_elements.numbering": "Sıralı sayılar oluşturmak için özel karakterler kullanabilirsiniz: grubundaki öğenin dizinini almak için %, seçim içindeki dizini almak için $.",
	"generic.edit_externally": "Harici Olarak Düzenle",
	"message.settings_require_restart.title": "Yeniden Başlatma Gerekli",
	"message.settings_require_restart.message": "Bazı ayarlar yalnızca program yeniden başlatıldıktan sonra uygulanacaktır.",
	"message.settings_require_restart.restart_now": "Şimdi Yeniden Başlat",
	"message.settings_require_restart.restart_later": "Daha Sonra Yeniden Başlat",
	"message.classroom_mode.install_plugin": "Sınıf Modunda eklenti yüklenemez",
	"dialog.collection.export_path": "Dışa Aktarma Yolu",
	"dialog.collection.select_all": "Tümünü Seç",
	"dialog.collection.select_none": "Hiçbirini Seçme",
	"dialog.collection.add_with_filter": "Filtre ile Ekle",
	"dialog.collection.remove": "Kaldır",
	"dialog.material_config.title": "Malzeme Yapılandırması",
	"dialog.material_config.color_value": "Renk Değeri",
	"dialog.material_config.mer": "Metal-Emisyon-Pürüzlülük",
	"dialog.material_config.mer_value": "MER Değeri",
	"dialog.material_config.depth_type": "Derinlik Tipi",
	"dialog.create_texture.disable_mirror_uv": "UV Aynalamayı Devre Dışı Bırak",
	"dialog.create_texture.disable_mirror_uv.desc": "Modelin her iki tarafı için ayrı UV'leri korumak amacıyla Ayna Modelleme'deki UV Ayna seçeneğini devre dışı bırakın",
	"dialog.create_gif.turn.sync_to_anim_length": "Animasyon uzunluğuyla senkronize et",
	"settings.category.controls": "Kontroller",
	"settings.classroom_mode": "Sınıf Modu",
	"settings.classroom_mode.desc": "Eklenti yükleme gibi işlevleri kısıtlar ve sosyal medya bağlantılarını kaldırır",
	"settings.antialiasing_bleed_fix": "Kenar yumuşatma kanamasını düzelt",
	"settings.antialiasing_bleed_fix.desc": "Kenar yumuşatma kullanırken doku kanamasını düzeltir. Potansiyel olarak eski donanımlarda desteklenmez.",
	"settings.tone_mapping": "Ton Eşleme",
	"settings.tone_mapping.desc": "PBR renderleme için standart bir ekranda yüksek dinamik aralığı görüntülemek için kullanılan yaklaştırma yöntemi.",
	"settings.audio_scrubbing": "Zaman Çizelgesi Sürükleme Sesi",
	"settings.audio_scrubbing.desc": "Zaman çizelgesinde sürüklerken sesin kısa önizlemelerini çalın",
	"settings.viewport_rotate_speed": "Görünüm Alanı Döndürme Hızı",
	"settings.viewport_rotate_speed.desc": "Görünüm alanında dönerken giriş hassasiyeti",
	"settings.viewport_zoom_speed": "Görünüm Alanı Yakınlaştırma Hızı",
	"settings.viewport_zoom_speed.desc": "Görünüm alanında yakınlaştırırken giriş hassasiyeti",
	"settings.editor_2d_zoom_speed": "2B Düzenleyici Yakınlaştırma Hızı",
	"settings.editor_2d_zoom_speed.desc": "UV ve 2B boya düzenleyicide yakınlaştırırken giriş hassasiyeti",
	"category.select": "Seç",
	"action.vertex_snap_mode.rotate": "Döndür",
	"action.export_image": "Görseli Dışa Aktar",
	"action.export_image.desc": "Dokunuzu bir görsel dosyası olarak dışa aktarın",
	"action.apply_mirror_modeling": "Ayna Modellemeyi Uygula",
	"action.apply_mirror_modeling.desc": "Seçime Ayna Modellemeyi uygulayın. Tüm seçili öğeler kopyalanacak ve X ekseninde çevrilecektir.",
	"action.create_collection": "Koleksiyon Oluştur",
	"action.create_collection.desc": "Anahat seçiminden bir koleksiyon oluşturun",
	"action.set_collection_content_to_selection": "Koleksiyon İçeriğini Seçili Olarak Ayarla",
	"action.set_collection_content_to_selection.desc": "Seçili grupları ve öğeleri koleksiyonun içeriği olarak ayarlayın",
	"action.add_to_collection": "Seçiliyi Koleksiyona Ekle",
	"action.add_to_collection.desc": "Seçili grupları ve öğeleri koleksiyona ekleyin",
	"action.view_mode.material": "Malzeme Önizleme",
	"action.create_material": "Malzeme Oluştur",
	"action.create_material.desc": "Seçili dokudan yeni bir PBR malzemesi oluşturun",
	"action.generate_pbr_map": "PBR Haritası Oluştur...",
	"action.generate_pbr_map.desc": "Mevcut bir dokudan bir PBR haritası (yükseklik haritası veya metaliklik, yayıcılık, pürüzlülük) oluşturun",
	"menu.tools.main_tools": "Araç Kutusu",
	"menu.view.panels": "Paneller",
	"menu.texture.pbr_channel": "PBR Kanalı",
	"menu.texture.pbr_channel.color": "Renk",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Yükseklik",
	"menu.texture.pbr_channel.mer": "MER (Metaliklik-Yayıcılık-Pürüzlülük)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Yüzey Altı",
	"menu.collection.export_project": "Projeyi Dışa Aktar",
	"menu.collection.export_as": "\"%0\" olarak Dışa Aktar",
	"menu.panel.enable": "Etkinleştir",
	"menu.panel.move_to": "Şuraya Taşı",
	"menu.panel.move_to.left_bar": "Sol Kenar Çubuğu",
	"menu.panel.move_to.right_bar": "Sağ Kenar Çubuğu",
	"menu.panel.move_to.top": "Üst",
	"menu.panel.move_to.bottom": "Alt",
	"menu.panel.move_to.float": "Yüzer",
	"menu.panel.move_to.hidden": "Gizle",
	"menu.panel.fold": "Daralt",
	"menu.mirror_painting.texture_center": "Merkez",
	"menu.mirror_modeling.mirror_uv": "UV'yi Aynala",
	"menu.animation_onion_skin.frames": "Kareler",
	"menu.animation_onion_skin.select": "Seç",
	"menu.animation_onion_skin.previous": "Önceki",
	"menu.animation_onion_skin.next": "Sonraki",
	"menu.animation_onion_skin.previous_next": "Önceki + Sonraki",
	"menu.animation_onion_skin.count": "Sayı",
	"menu.animation_onion_skin.interval": "Aralık",
	"menu.animation_onion_skin_selective": "Seçici Soğan Zarı",
	"menu.animation_onion_skin_selective.desc": "Yalnızca modelın seçili kısmı için soğan zarı görüntüsü göster",
	"edit.loop_cut.unit": "Birim",
	"edit.loop_cut.unit.size_units": "Boyut Birimleri",
	"edit.loop_cut.unit.percent": "Yüzde",
	"edit.extrude_mesh_selection.direction": "Yön",
	"edit.extrude_mesh_selection.direction.outwards": "Dışa Doğru",
	"edit.extrude_mesh_selection.direction.average": "Ortalama",
	"edit.extrude_mesh_selection.even_extend": "Eşit Genişlet",
	"edit.vertex_snap.align": "Hizala",
	"edit.vertex_snap.align.longest": "En Uzun Eksen",
	"edit.vertex_snap.align.direction": "Merkezden Yön",
	"edit.vertex_snap.align.align_axis": "%0 Ekseni",
	"edit.vertex_snap.ignore_axis": "Ekseni Yoksay",
	"codec.common.format": "Format",
	"codec.image.quality": "Kalite",
	"panel.collections": "Koleksiyonlar",
	"modifier_actions.always": "Her Zaman Etkin",
	"modifier_actions.unless": "%0 olmadıkça",
	"settings.undo_selections": "Seçimi Geri Al",
	"settings.undo_selections.desc": "Seçim değişikliklerini geri alma geçmişinde bir adım olarak izle",
	"action.focus_on_selection.zoom": "Sığacak şekilde yakınlaştır",
	"display.reference.tooting": "Korna Çalma",
	"settings.selection_tolerance": "Seçim Toleransı",
	"settings.selection_tolerance.desc": "Bir kenarı veya tepe noktasını seçmek için tıklanabilecek alanın boyutu",
	"action.delete.keep_vertices": "Kenarları/Tepe Noktalarını Koru",
	"menu.mesh": "Ağ",
	"dialog.material_config.subsurface": "Yüzey Altı Saçılması",
	"dialog.material_config.subsurface_enabled.desc": "Yüzey altı saçılması için MER haritası alfa kanalını kullanın",
	"settings.pick_combined_color": "Birleşik Rengi Seç",
	"settings.pick_combined_color.desc": "Aktif katmandaki renk yerine, ilgili pikseldeki tüm katmanların birleşik rengini seçin",
	"action.split_rgb_into_layers": "RGB Kanallarını Katmanlara Böl",
	"action.split_rgb_into_layers.desc": "Dokuyu, her RGB kanalı için bir tane olmak üzere, toplanabilir katmanlara bölün",
	"dialog.project.java_block_version": "Format Sürümü",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armatür",
	"data.armature_bone": "\n",
	"generic.reload": "Yeniden Yükle",
	"modifier_actions.subtract": "Çıkar",
	"modifier_actions.reduced_intensity": "Hassas Ayar",
	"modifier_actions.select_bone": "Kemiği Seç",
	"modifier_actions.spline_select_multiple_points": "Birden Fazla Nokta veya Tutamaç Seç",
	"modifier_actions.move_panel_without_docking": "Paneli sabitlemeden taşı",
	"message.save_all_textures.message": "Aşağıdaki dokuların her birini kaydetmek istiyor musunuz?",
	"message.save_all_textures.skip": "Atla",
	"dialog.add_spline.shape": "Şekil",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Dikdörtgen",
	"dialog.add_spline.shape.circle": "Daire",
	"dialog.add_spline.diameter": "Çap",
	"dialog.add_spline.sides_tubular": "Tüp Segmentleri",
	"dialog.add_spline.sides_radial": "Halka Segmentleri",
	"dialog.add_spline.radius": "Tüp Yarıçapı",
	"dialog.add_spline.length": "Uzunluk",
	"dialog.add_spline.width": "Genişlik",
	"dialog.plugins.revoke_permissions": "İzinleri İptal Et",
	"dialog.expression_editor.pretty_print": "Okunabilir Format",
	"dialog.expression_editor.minify": "Küçült",
	"dialog.expression_editor.find_replace": "Bul/Değiştir",
	"dialog.create_gif.show_gizmos": "Yardımcıları ve Izgarayı Kaydet",
	"dialog.preview_options.title": "Önizleme Seçenekleri",
	"dialog.preview_options.background": "Arka Plan",
	"dialog.preview_options.background.checkerboard": "Dama Tahtası",
	"dialog.preview_options.background.solid": "Düz Renk",
	"dialog.preview_options.background.custom_color": "Özel Renk",
	"dialog.preview_options.show_gizmos": "Yardımcıları Göster",
	"dialog.skin.texture_source": "Doku Kaynağı",
	"dialog.skin.texture_source.template": "Şablon Oluştur",
	"dialog.skin.texture_source.load_texture": "Minecraft'tan Yükle",
	"dialog.skin.texture_file": "Doku Dosyası",
	"dialog.convert_skin.adjust_texture": "Dokuyu Ayarla",
	"dialog.settings.clear_profile_value": "Profil Değerini Temizle",
	"layout.section.customize": "Özelleştir",
	"layout.theme.configure": "Yapılandır",
	"layout.color.elevated": "Yükseltilmiş",
	"layout.color.elevated.desc": "Genellikle gölge ile ayrılmış, yükseltilmiş UI öğeleri",
	"layout.file.watch_changes": "Değişiklikleri izle ve yeniden yükle",
	"settings.autocomplete_code": "Kodu Otomatik Tamamla",
	"settings.autocomplete_code.desc": "Kod Düzenleyicisinde otomatik tamamlama önerileri göster",
	"settings.detect_flipbook_textures": "Flipbook Dokularını Algıla",
	"settings.detect_flipbook_textures.desc": "Flipbook animasyonlu dokuları otomatik olarak algıla ve animasyon olarak önizle",
	"settings.double_click_select_reference": "Referans görselini çift tıklamayla seç",
	"settings.double_click_select_reference.desc": "Referans görselini seçmek için görünüm alanına çift tıklayın",
	"settings.default_keyframe_interpolation": "Varsayılan Anahtar Kare İnterpolasyonu",
	"settings.default_keyframe_interpolation.desc": "Varsayılan anahtar kare interpolasyon modunu seçin",
	"settings.color_picker_style": "Renk Seçici Stili",
	"settings.color_picker_style.desc": "Boyama modu renk seçicisi için bir stil seçin",
	"settings.export_asset_paths": "Varlık Yollarını Dışa Aktar",
	"settings.export_asset_paths.desc": "Dokular veya animasyonlar gibi varlıkların yollarının .bbmodel dosyalarına nasıl kaydedileceğini seçin",
	"settings.export_asset_paths.relative": "Göreceli Yollar",
	"settings.export_asset_paths.absolute": "Tam Yollar",
	"settings.export_asset_paths.both": "Göreceli ve Tam Yollar (Sadece Doku)",
	"settings.export_asset_paths.none": "Dışa Aktarma Yok",
	"action.slider_spline_resolution": "Spline Çözünürlüğü %0",
	"action.slider_spline_resolution.desc": "%0 ekseninde spline çözünürlüğünü değiştir (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Halka Segmentleri",
	"action.slider_spline_resolution.v.desc_precision": "Tüp Segmentleri",
	"action.slider_spline_radius": "Spline Yarıçapı",
	"action.slider_spline_radius.desc": "Spline yarıçapını değiştir",
	"action.slider_spline_handle_tilt": "Tutamak Eğimi",
	"action.slider_spline_handle_tilt.desc": "Spline tutamak eğimini değiştir",
	"action.slider_spline_handle_size": "Tutamak Boyutu",
	"action.slider_spline_handle_size.desc": "Spline tutamak boyutunu değiştir",
	"action.blend_mode.lighten": "Aydınlat",
	"action.blend_mode.darken": "Karart",
	"action.weight_brush": "Ağırlık Fırçası",
	"action.weight_brush.desc": "Armatür deformasyonları için ağlar üzerinde tepe noktası ağırlıklarını boyayın",
	"action.convert_minecraft_skin_variant": "İnce/Klasik Kaplamaya Dönüştür",
	"action.convert_minecraft_skin_variant.desc": "Kaplama modelini klasik geniş (Steve) modeli ile ince (Alex) modeli arasında değiştirin. İsteğe bağlı olarak dokuyu modele uyacak şekilde otomatik ayarlayın",
	"action.custom_skin_poses": "Özel Kaplama Pozları",
	"action.custom_skin_poses.desc": "Özel bir kaplama pozu ön ayarı yükleyin",
	"action.custom_skin_poses.update": "Pozu Güncelle",
	"action.custom_skin_poses.update.desc": "Kaydedilen pozu modelin mevcut pozuyla değiştirin",
	"action.add_custom_skin_pose": "Özel Kaplama Pozu Ekle",
	"action.add_custom_skin_pose.desc": "Modelin mevcut pozunu poz ön ayarı olarak kaydedin",
	"action.export_stl": "STL Olarak Dışa Aktar",
	"action.export_stl.desc": "STL modelini 3D yazdırma için kaydedin",
	"action.add_element": "Öğe Ekle",
	"action.add_element.desc": "Öğe türleri listesinden yeni bir öğe ekleyin",
	"action.add_spline": "Spline Ekle",
	"action.add_spline.desc": "Yeni bir spline ekler",
	"action.add_billboard": "Billboard Ekle",
	"action.add_billboard.desc": "Her zaman kameraya bakan düz bir öğe olan yeni bir billboard ekler",
	"action.add_armature": "Armatür Ekle",
	"action.add_armature.desc": "Bir ağın animasyon aracılığıyla deforme edilmesini sağlayan bir armatür ekler",
	"action.add_armature_bone": "Armatür Kemiği Ekle",
	"action.add_armature_bone.desc": "Armatüre bir kemik ekler",
	"action.search_textures": "Dokularda Ara",
	"action.search_textures.desc": "Dokuları isme göre arayın",
	"action.search_animations": "Animasyonlarda Ara",
	"action.search_animations.desc": "Animasyonları isme göre arayın",
	"action.spline_selection_mode": "Spline Seçim Modu",
	"action.spline_selection_mode.object": "Nesne",
	"action.spline_selection_mode.handles": "Tutamaklar",
	"action.spline_render_mode": "Geometri",
	"action.spline_render_mode.mesh": "Ağ",
	"action.spline_render_mode.path": "Yol",
	"action.spline_render_mode.desc": "Bu spline'ın hangi geometriyi render edeceği",
	"action.spline_uv_mode": "UV Tarzı",
	"action.spline_uv_mode.length_accurate": "Doğru Uzunluk",
	"action.spline_uv_mode.uniform": "Tekdüze",
	"action.spline_uv_mode.per_segment": "Segment Başına",
	"action.spline_uv_mode.desc": "Spline'ın tüp ağının UV'lerini nasıl yerleştireceği",
	"action.spline_ring_segments": "Halka Segmentleri",
	"action.spline_ring_segments.desc": "Bu spline'ın her tüp halkası başına kaç alt bölüme sahip olduğu",
	"action.spline_tube_segments": "Tüp Segmentleri",
	"action.spline_tube_segments.desc": "Bu spline'ın yolu boyunca kaç alt bölüme sahip olduğu",
	"action.spline_tube_radius": "Tüp Yarıçapı",
	"action.spline_tube_radius.desc": "Spline'ın tüp yarıçapını ayarlayın",
	"action.spline_display_space": "Görüntüleme Alanı",
	"action.spline_display_space.desc": "Yolu üzerinde spline alanı göstergelerini görüntüle",
	"action.spline_handle_mode": "Spline Tutamak Modu",
	"action.spline_handle_mode.desc": "Spline tutamaklarını dönüştürmek için hangi modun kullanılacağı",
	"action.spline_handle_mode.aligned": "Hizalı",
	"action.spline_handle_mode.free": "Serbest",
	"action.spline_handle_mode.mirrored": "Aynalı",
	"action.slider_weight_brush_size": "Ağırlık Fırçası Boyutu",
	"action.weight_brush_xray": "Ağırlık Fırçası X-Ray Modu",
	"action.weight_brush_xray.desc": "Etkinleştirildiğinde, ağırlık fırçası sadece yüzeyde görünenleri değil, tüm tepe noktalarını etkiler",
	"action.apply_spline_rotation": "Döndürmeyi Uygula",
	"action.apply_spline_rotation.desc": "Spline'ın öğe döndürmesini sıfırlayın ve bunun yerine geometriye uygulayın",
	"action.extrude_spline_selection": "Spline Dışa Çıkar",
	"action.extrude_spline_selection.desc": "Tüm spline'larda seçili tutamağı dışa çıkarın",
	"action.split_spline": "Spline Böl",
	"action.split_spline.desc": "Spline'ı seçili tutamaktan ikiye böler",
	"action.divide_spline_curve": "Spline Segmentini Böl",
	"action.divide_spline_curve.desc": "Spline segmentini kesişim noktalarında yeni bir tutamaçla iki yeni segmente böler",
	"action.set_vertex_weights": "Tepe Noktası Ağırlıklarını Ayarla",
	"action.set_vertex_weights.desc": "Seçili tepe noktalarının ağırlıklarını belirli bir armatür kemiği üzerinde belirli bir değere ayarlayın",
	"action.calculate_vertex_weights": "Tepe Noktası Ağırlıklarını Hesapla",
	"action.calculate_vertex_weights.desc": "Kemiklerin konumuna göre tepe noktası ağırlıklarını otomatik olarak ata",
	"action.shelf_alignment": "Raf Hizalaması",
	"action.shelf_alignment.desc": "Raftaki öğelerin dikey hizalamasını seçin",
	"action.shelf_alignment.top": "Üst Hizalama",
	"action.shelf_alignment.bottom": "Alt Hizalama",
	"action.view_mode.vertex_weight": "Tepe Noktası Ağırlığı",
	"action.view_mode.weighted_bone_colors": "Tepe Noktası Kemik Renkleri",
	"action.create_animation_group": "Animasyon Grubu Oluştur",
	"action.create_animation_group.desc": "Animasyonlardan oluşan bir grup oluşturun",
	"action.move_graph_keyframes_up": "Grafik Anahtar Karelerini Yukarı Taşı",
	"action.move_graph_keyframes_down": "Grafik Anahtar Karelerini Aşağı Taşı",
	"menu.skin": "Kaplama",
	"menu.text_edit.expression_editor": "İfade Düzenleyici",
	"menu.color_picker.picker_type.normal": "Normal Harita",
	"menu.texture.flipbook_animation": "Flipbook Animasyonu",
	"menu.panel.attach_to": "Şuraya Ekle",
	"menu.animation.playing": "Oynatılıyor",
	"menu.animation_file.save_as": "Farklı Kaydet",
	"menu.animator.quaternion_interpolation": "Kuaternion İnterpolasyonu",
	"edit.extrude_spline_selection.extend": "Uzat",
	"edit.divide_spline_curve.position": "Pozisyon",
	"group.bedrock_binding": "Bağlantı",
	"group.cem_attach": "CEM Ekle",
	"group.cem_model": "CEM Modeli",
	"group.cem_scale": "CEM Ölçeği",
	"cube.rescale": "Döndürme Ölçeklendirmesi",
	"cube.rescale.desc": "Döndürme açısını telafi etmek için kübü yeniden ölçeklendir",
	"mesh.shading": "Gölgelendirme",
	"mesh.shading.flat": "Düz",
	"mesh.shading.smooth": "Yumuşak",
	"spline_mesh.cyclic": "Döngüsel (Cyclic)",
	"spline_mesh.cyclic.desc": "Seçili spline'ın bir döngü oluşturup oluşturmayacağı",
	"billboard.offset": "Ofset",
	"billboard.facing_mode": "Yönelme Modu",
	"billboard.facing_mode.lookat": "Bak",
	"billboard.facing_mode.lookat_y": "Y Eksenine Bak",
	"billboard.facing_mode.rotate": "Döndür",
	"billboard.facing_mode.rotate_y": "Y Ekseninde Döndür",
	"armature_bone.connected": "Bağlı",
	"reference_image.blueprint": "Kilitli Plan",
	"codec.image.alpha_channel": "Alfa Kanalı",
	"codec.image.animation_fps": "Animasyon FPS",
	"panel.palette": "Palet",
	"panel.keyframe.change_effect_file": "Efekt Dosyasını Değiştir",
	"panel.transform": "Dönüştür",
	"panel.element.spline_dimensions": "Spline Boyutları",
	"display.slot.on_shelf": "Raf",
	"display.reference.shelf": "Raf (Tüm Yuvalar)",
	"display.reference.shelf_left": "Raf (Sol Yuva)",
	"display.reference.shelf_center": "Raf (Orta Yuva)",
	"display.reference.shelf_right": "Raf (Sağ Yuva)",
	"message.newer_project_format_version.title": "Eski istemci",
	"message.newer_project_format_version.message": "Bu dosya Blockbench'in daha yeni bir sürümünde kaydedildi. Doğru şekilde açabilmek için lütfen Blockbench %0 veya daha yeni bir sürüme güncelleyin",
	"message.load_images.add_layer": "Katman Olarak Ekle",
	"message.load_images.category.add_to_project": "Projeye ekle",
	"message.load_images.category.new_project": "Yeni proje",
	"message.load_palette.title": "Palet Yükle",
	"message.load_palette.message": "Bu paleti yüklemek istediğinizden emin misiniz? Mevcut renk paletinizin yerini alacaktır.",
	"dialog.set_vertex_weights.weight": "Ağırlık",
	"dialog.set_vertex_weights.overwrite": "Diğer kemiklerin üzerine yaz",
	"action.element_render_order.short": "İşleme Sırası",
	"action.element_render_order.desc": "Öğelerin işleme sırası. Bu, şeffaf dokulu öğelerin arkasında gizlenen öğelerin düzeltilmesine yardımcı olabilir. Opak öğeler için Otomatik'te bırakın.",
	"spline.shading.flat": "Düz",
	"spline.shading.smooth": "Yumuşak",
	"spline.shading": "Gölgelendirme",
	"spline.shading.desc": "Bu spline'ın tüpünün nasıl gölgelendirileceği",
	"action.slider_weight_brush_limit": "Ağırlık Fırçası Sınırı",
	"action.slider_weight_brush_limit.desc": "Ağırlık fırçasının bir tepe noktasına atayabileceği ağırlık için üst bir sınır belirleyin",
	"action.weight_brush_blend_mode": "Ağırlık Fırçası Karışım Modu",
	"action.weight_brush_blend_mode.set": "Ayarla",
	"action.weight_brush_blend_mode.add": "Ekle",
	"action.apply_texture_to_elements": "Dokuyu Öğelere Uygula",
	"action.apply_texture_to_elements.desc": "Seçili dokuyu seçili öğelere uygula",
	"menu.panel.reset_size": "Boyutu Sıfırla",
	"action.import_layer": "Katmanı İçe Aktar",
	"action.import_layer.desc": "Görsel dosyalarını katman olarak içe aktar",
	"menu.collection.open_file": "Dosyayı Aç",
	"layout.version": "Sürüm",
	"settings.status_bar_transform_sliders": "Durum Çubuğunda Dönüşüm Kaydırıcıları",
	"settings.status_bar_transform_sliders.desc": "Dönüştürme paneli yerine durum çubuğunda seçili aracın dönüşüm kaydırıcıları araç çubuğunu görüntüle",
	"settings.default_bedrock_format": "Varsayılan Bedrock Formatı",
	"settings.default_bedrock_format.desc": "Bağlamdan belirli bir format algılanamadığında Minecraft Bedrock modellerinin yükleneceği varsayılan formatı seçin.",
	"settings.limit_brush_opacity_per_stroke": "Fırça Opaklığını Darbe Başına Sınırla",
	"settings.limit_brush_opacity_per_stroke.desc": "Fırçanın her bir fırça darbesi sırasında uygulayabileceği opaklığı, opaklık kaydırıcısının değeriyle sınırla. Yumuşak bir fırça ile bu davranış potansiyel olarak hafif istenmeyen gürültüye yol açabilir.",
	"action.merge_splines": "Spline'ları Birleştir",
	"action.merge_splines.desc": "Birden fazla spline'ı tek bir spline'da birleştirin",
	"settings.default_java_block_version": "Varsayılan Java Blok/Eşya Sürümü",
	"settings.default_java_block_version.desc": "Yeni Java blok/eşya modelleri oluştururken veya format sürümü olmayan dosyaları açarken varsayılan format sürümü",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot",
	"data.generated_item_mesh": "Generated Item Model",
	"message.generated_item_model.title": "Generated Item Model",
	"message.generated_item_model.message": "This model has no elements of its own. Minecraft builds the item shape from the model's texture, so what you see here is only a preview of that shape. It cannot be edited, and is not exported.\n\nTo change how the item looks in game, edit the texture.",
	"message.generated_item_model.edit_texture": "Edit Texture",
	"message.generated_item_model.convert": "Convert to Editable Model",
	"message.convert_generated_item_model.title": "Convert to Editable Model",
	"message.convert_generated_item_model.message": "This builds real elements by extruding the texture, so you can change the item shape in 3D.\n\nIf you only want to change how the item looks, you do not need this. Edit the texture instead, and Minecraft will keep generating the shape from it.",
	"message.convert_generated_item_model.confirm": "Extrude Texture",
	"message.generated_item_model_conflict.title": "Generated Item Model",
	"message.generated_item_model_conflict.message": "Minecraft cannot use both a generated item model and elements. Now that this model has elements, the generated shape is ignored in game.",
	"message.generated_item_model_conflict.convert": "Convert the Generated Model to Cubes",
	"message.generated_item_model_conflict.convert.desc": "Extrude the texture into real elements, so nothing is lost",
	"message.generated_item_model_conflict.remove": "Remove the Generated Model",
	"message.generated_item_model_conflict.remove.desc": "Delete the preview and model the item from scratch",
	"message.generated_item_model_conflict.keep": "Keep It as a Reference",
	"message.generated_item_model_conflict.keep.desc": "Show it in Blockbench only, never exported",
	"message.add_reference_image.globally": "Add for all projects",
	"dialog.extrude.orientation.upright_z": "Upright Z",
	"dialog.extrude.depth": "Depth",
	"dialog.add_primitive.shape.icosphere": "Icosphere",
	"dialog.add_primitive.shape.octahedron": "Octahedron",
	"dialog.add_primitive.shape.dodecahedron": "Dodecahedron",
	"dialog.add_primitive.detail": "Detail",
	"dialog.plugins.update": "Update",
	"dialog.plugins.update_available": "Update Available",
	"dialog.create_variable_placeholder.variable": "Variable",
	"dialog.create_variable_placeholder.type": "Type",
	"dialog.create_variable_placeholder.type.value": "Value",
	"dialog.create_variable_placeholder.type.slider": "Slider",
	"dialog.create_variable_placeholder.type.toggle": "Toggle",
	"dialog.create_variable_placeholder.type.impulse": "Impulse",
	"dialog.create_variable_placeholder.value": "Value",
	"dialog.create_variable_placeholder.duration": "Duration",
	"dialog.create_variable_placeholder.step": "Step",
	"dialog.create_variable_placeholder.range": "Range",
	"dialog.create_variable_placeholder.output": "Output",
	"dialog.view_built_in_variables.function": "Parameters required",
	"dialog.advanced_screenshot.export": "Export",
	"dialog.preview_options.show_element_markers": "Show Element Markers",
	"dialog.preview_options.show_element_markers.desc": "Display markers to indicate the position for elements such as bones, null objects, and locators",
	"settings.maximum_zoom_distance": "Maximum Zoom Distance",
	"settings.maximum_zoom_distance.desc": "How far the camera can be zoomed away from the model",
	"settings.constant_outlines": "Constant Outlines",
	"settings.constant_outlines.desc": "Always display element outlines regardless of selection",
	"settings.new_project_dialog": "New Project Dialog",
	"settings.new_project_dialog.desc": "Show the Project dialog when creating a new project",
	"settings.opacity_range": "Opacity Range",
	"settings.opacity_range.desc": "Select which range is used to control opacity of layers and brushes",
	"settings.automatic_plugin_updates": "Automatic Plugin Updates",
	"settings.automatic_plugin_updates.desc": "Automatically update plugins to keep them up-to-date",
	"settings.native_window_frame": "Native Window Frame",
	"settings.native_window_frame.desc": "Use a native window frame in the style of the OS",
	"keybind.preview_scroll_pan": "Scroll Pan View",
	"keybind.preview_scroll_pan.desc": "Use scroll to pan the view, can be used for two-finger panning with trackpads",
	"action.position_slider_per_element": "Move Individual Positions",
	"action.position_slider_per_element.desc": "When enabled, using the position sliders changes individual positions per element. When disabled, the whole selection moves in the selected transform space.",
	"action.origin_slider_direct_values": "Move Pivot Values Directly",
	"action.origin_slider_direct_values.desc": "When enabled, pivot sliders will move the pivot point directly, affecting the position of the object. When disabled, positions get adjusted automatically.",
	"action.brush_lock_mode": "Brush Lock Mode",
	"action.brush_lock_mode.none": "Unlocked",
	"action.brush_lock_mode.element": "Lock to Element",
	"action.brush_lock_mode.face": "Lock to Face",
	"action.slider_brush_aspect_ratio": "Brush Aspect Ratio",
	"action.slider_brush_aspect_ratio.desc": "Aspect ratio of the brush",
	"action.screen_space_brush_projection": "Screen Space Brush Projection",
	"action.screen_space_brush_projection.desc": "Use screen space projection for painting with a brush",
	"action.close_other_projects": "Close Other Tabs",
	"action.close_other_projects.desc": "Closes all projects except the open project",
	"action.close_projects_to_right": "Close Tabs to the Right",
	"action.close_projects_to_right.desc": "Closes all project tabs to the right of the open project",
	"action.extrude_texture_to_model": "Extrude Texture",
	"action.extrude_texture_to_model.desc": "Generate a model by extruding this texture",
	"action.experimental_settings": "Experimental Settings",
	"action.experimental_settings.desc": "Customize experimental developer settings",
	"action.convert_texture_mesh_to_cubes": "Convert to Extruded Model",
	"action.convert_texture_mesh_to_cubes.desc": "Replace the texture mesh with cubes extruded from its texture, in the same place",
	"action.flip_in_place": "Flip in Place %0",
	"action.flip_in_place.desc": "Flip the selected elements on the %0 axis in its current position",
	"action.create_layer_group": "Create Layer Group",
	"action.resolve_layer_group": "Resolve Layer Group",
	"action.preview_models": "Preview Models",
	"action.preview_models.desc": "Select and edit reference models",
	"action.keyframe_select_before_playhead": "Select Keyframes Before Playhead",
	"action.keyframe_select_before_playhead.desc": "Select all keyframes in the timeline at or before the playhead",
	"action.keyframe_select_after_playhead": "Select Keyframes After Playhead",
	"action.keyframe_select_after_playhead.desc": "Select all keyframes in the timeline at or after the playhead",
	"action.set_ik_pole": "Set IK Pole",
	"action.set_ik_pole.desc": "Select the pole that the chain will attempt to face towards while moving",
	"action.create_variable_placeholder": "Create Variable Placeholder",
	"action.create_variable_placeholder.desc": "Add a variable to the variable placeholders list to preview a value",
	"action.view_built_in_variables": "View Built-in Variables",
	"action.view_built_in_variables.desc": "Display the list of variables and their values that Blockbench automatically provides for animation preview",
	"menu.paint": "Paint",
	"menu.brush_presets.screen_space": "Screen Space Brush",
	"edit.loop_cut.spacing": "Spacing",
	"edit.loop_cut.spacing.proportional": "Proportional",
	"edit.loop_cut.spacing.even_start": "Even - From Start",
	"edit.loop_cut.spacing.even_end": "Even - From End",
	"cube.shade_direction_override": "Shade Direction Override",
	"cube.shade_direction_override.desc": "Shade every face of the cube as if it was facing this direction. If not set, each face is shaded based on the direction it actually faces. This does not affect ambient occlusion or shading based on light level.",
	"null_object.ik_target": "IK Target",
	"null_object.ik_source": "IK Root",
	"null_object.ik_pole": "IK Pole",
	"reference_image.layer.scene": "3D Scene",
	"reference_image.view_mode": "View Mode",
	"reference_image.view_mode.flat_image": "Flat Image",
	"reference_image.cull_backface": "Hide Backside",
	"codec.common.merge_armature_mesh": "Merge Armature Mesh",
	"preview_model.transform": "Transform",
	"preview_model.reset_transform": "Reset Transform",
	"preview_model.minecraft_player": "Minecraft Player",
	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor",
	"message.child_model_only.resolve": "Resolve Parent Models",
	"message.child_model_only.resolve.desc": "Merge the whole parent chain into this model",
	"message.child_model_only.open.desc": "Open the parent in a new tab, keeping it separate from this model",
	"action.brush_lock_mode.selected_faces": "Lock to Selected Faces",
	"reference_image.view_mode.plane": "3D Plane",
	"preview_model.minecraft_crafting_table": "Minecraft Crafting Table",
	"dialog.extrude.animated": "Animated Texture",
	"dialog.scale.box_uv_warning_required": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or use Inflate.",
	"menu.color_picker.picker_type.wheel_static": "Wheel (Static)"
}